import { useEffect, useMemo, useRef, useState } from "react";
import { Form, Col, Row, Modal, Button } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import usePut from "../../../global/hooks/usePut";
import useDelete from "../../../global/hooks/useDelete";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";

import {
  CheckCircleOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  UnorderedListOutlined,
  InfoCircleOutlined,
  SettingOutlined,
  LoginOutlined,
  FolderOpenOutlined,
  GiftFilled,
} from "@ant-design/icons";
// import CustomSwitch from "../../../global/components/inputWidgets/CustomSwitch";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import ConfirmModal from "../../../global/components/ConfirmModal";
import { FaCalendarDays, FaGlobe } from "react-icons/fa6";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import AccountCreationModal from "../../../global/components/AccountCreationModal";
import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import PaymentIcon from "../../../assets/images/vectors/SideBarIcons/PaymentIcon";
import DealerIcon from "../../../assets/images/vectors/SideBarIcons/DealerIcon";
import AccountIcon from "../../../assets/images/vectors/SideBarIcons/AccountIcon";
import { hasRole } from "../../../global/hooks/getUserRole";
import CommonModal from "../../../global/components/CommonModal";
import LicenseIcon from "../../../assets/images/vectors/SideBarIcons/LicenseIcon";
import { LicenseSelectForm } from "../../Device/Components/LicenseSelectForm";
import { macValidator } from "../../../global/utils/macValidator";
import { normalizeEmailValue } from "../../../global/utils/normalizeFormEmails";
import {
  calculateDoorPrice,
  calculateLicenseTypePrice,
  calculateSiteTypePrice,
  calculateTotals,
  applyExpiredToOptions,
  enrichGiftCardOptionsWithChannelMobileChildren,
  getCodeValueForGiftCard,
  getItemNoByLabel,
  getPrice,
  inputCardOptions,
  licenseOptions,
  mergeGiftCardItemsState,
  validateGiftCardItemsOldCodeMatchesForm,
  modelIconMap,
  modelOptions,
  orderTypeOptions,
  productIconMap,
  productOptions,
  resolveLicenseTypeFromSiteType,
  siteTypeIconMap,
  siteTypeOptions,
} from "../../../utils/Common";
import DoorTypeIcon from "../../../assets/images/vectors/DoorTypeIcon";
import OptionCards from "../../../global/components/inputWidgets/OptionCards";
import LicenseConfirmForm from "../../License/Components/LicenseConfirmModal";
import { GiftCardItemsForm } from "./GiftCardItemsForm";
import { LimitedLicenseForm } from "./LimitedLicenseForm";
import { LimitedLicenseConfirmForm } from "./LimitedLicenseConfirmForm";
import { getUserRoles } from "../../../global/components/PrivateRoute";
import { useAuthData } from "../../../providers/AuthProvider";
import MyPaymentForm from "../../../global/components/PaymentForm";
import { ManageCardsModal } from "../../../global/components/ManageCardsModal";
import {
  AUTOBILLING_CARD_REQUIRED_MESSAGE,
  fetchDealerHasSavedCards,
  normalizeAutoBilling,
} from "../../../global/utils/cardPaymentUtils";
import {
  buildLimitedLicenseSummary,
  pickCurrentLimitedOrder,
} from "../../../utils/limitedLicense";

export const MySiteForm = ({ type }) => {
  const { userData } = useAuthData();
  const { isSystemUser, isCustomerUser, isDealerUser, isOemUser } =
    getUserRoles(userData);
  const [showModal, setShowModal] = useState(false);
  const [autoLogin, setAutoLogin] = useState(0);
  const [defaultData, setDefaultData] = useState({
    DealerNo: null,
    OemNo: null,
    CustomerNo: null,
  });
  const [OemNo, setOemNo] = useState(null);
  const [dealerNo, setDealerNo] = useState(null);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [sitetype, setSiteType] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [showCommonModal, setShowCommonModal] = useState(false);
  const [showGiftCardModal, setShowGiftCardModal] = useState(false);
  const [showLimitedLicenseModal, setShowLimitedLicenseModal] = useState(false);
  const [showLimitedLicenseSummary, setShowLimitedLicenseSummary] =
    useState(false);
  const [limitedLicenseSummary, setLimitedLicenseSummary] = useState(null);
  const [limitedApplyDisabled, setLimitedApplyDisabled] = useState(false);
  const giftCardRef = useRef(null);
  const limitedLicenseRef = useRef(null);
  /** After site PUT succeeds, POST this body to mark prepurchased items used */
  const pendingGiftCardMarkUsedPayloadRef = useRef(null);
  const giftCardAwaitingSitePutRef = useRef(false);
  const prevGiftCardPostLoadingRef = useRef(false);
  const selectedLimitedCardRef = useRef(null);

  const giftCardPostUrl = `${process.env.REACT_APP_API_URL}/api/devices/gift-card-items/`;
  const {
    data: giftCardPostData,
    loading: giftCardPostLoading,
    error: giftCardPostError,
    postData: giftCardPostAction,
  } = usePost(giftCardPostUrl);
  const limitedOrderUrl = `${process.env.REACT_APP_API_URL}/api/limited/orders/`;
  const { postData: limitedOrderPostAction } = usePost(limitedOrderUrl);
  const [licenseSiteType, setLicenseSiteType] = useState(null);
  const [licenseTypePrice, setLicenseTypePrice] = useState(0);
  const [siteTypePrice, setSiteTypePrice] = useState(0);
  const [doorPrice, setDoorPrice] = useState(0);
  const [licenseType, setLicenseType] = useState(0);
  const [licenseOptionsData, setLicenseOptionsData] = useState({});
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [pendingFormData, setPendingFormData] = useState(null);
  const [formValuesData, setFormValuesData] = useState(null);
  const [originalLicenseData, setOriginalLicenseData] = useState(null);
  const [paymentModal, setPaymentModal] = useState(false);
  const [showCardLayout, setShowCardLayout] = useState(!isSystemUser);
  const [pendingUpdatePayload, setPendingUpdatePayload] = useState(null);
  const [pendingSubmitMode, setPendingSubmitMode] = useState(null);
  const [priceChangeAmount, setPriceChangeAmount] = useState(0);
  const [showCardsModal, setShowCardsModal] = useState(false);
  const [cardsModalDealerNo, setCardsModalDealerNo] = useState(null);
  const isPaymentTriggeredApiRef = useRef(false);
  const paymentFlowInProgressRef = useRef(false);
  /** Skip put-success toast/navigate when limited-license flow already handles them */
  const skipNextSitePutSuccessRef = useRef(false);

  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const url = id
    ? `${process.env.REACT_APP_API_URL}/api/sites/${id}/`
    : undefined;

  const optionUrl = `${process.env.REACT_APP_API_URL}/api/devices/options/`;
  const licenseOptionUrl = `${process.env.REACT_APP_API_URL}/api/licenses/options/`;
  const { data: licenseOptionData, loading: optionDataLoading } =
    useGet(licenseOptionUrl);

  const modifiedOpLicense = useMemo(
    () =>
      licenseOptionData?.data?.options?.map((entry, index) => {
        return {
          value: `${entry?.value}`,
          label: entry.name,
        };
      }),
    [licenseOptionData],
  );
  const postUrl = `${process.env.REACT_APP_API_URL}/api/sites/`;
  const putUrl = `${process.env.REACT_APP_API_URL}/api/sites/${id}/`;
  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/sites/${id}/`;
  const { data, loading, error, refetch } = useGet(url);

  const limitedOrdersPreviewDeviceNo =
    type === "info"
      ? (data?.data?.DeviceNo ?? (id != null && id !== "" ? Number(id) : null))
      : null;
  const limitedOrdersPreviewUrl =
    limitedOrdersPreviewDeviceNo != null &&
    !Number.isNaN(Number(limitedOrdersPreviewDeviceNo))
      ? `${process.env.REACT_APP_API_URL}/api/limited/orders/?DeviceNo=${limitedOrdersPreviewDeviceNo}&limit=20&sort_by=OrderNo&order=desc`
      : null;
  const { data: limitedOrdersPreviewData } = useGet(limitedOrdersPreviewUrl);

  const codesUrl = `${process.env.REACT_APP_API_URL}/api/licensecodes/codes/?limit=100`;
  const {
    data: codesData,
    loading: codesDataLoading,
    error: codesDataError,
    refetch: codesDataRefetch,
  } = useGet(codesUrl);

  const {
    data: optionsData,
    error: optionDataError,
    refetch: optionDataRefetch,
  } = useGet(optionUrl);
  const [params, setParams] = useState({
    limit: 10,
    Mac: "",
    SiteKey: "",
  });
  const query = new URLSearchParams(params).toString();
  const searchurl =
    params.Mac && params.SiteKey
      ? `${process.env.REACT_APP_API_URL}/api/sites/?${query}`
      : undefined;
  const { data: searchData, loading: searchDataLoading } = useGet(searchurl);

  const dealerOptionsUrl =
    OemNo || data?.data?.OemNo || defaultData?.OemNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${
          OemNo
            ? OemNo
            : defaultData?.OemNo
              ? defaultData.OemNo
              : data?.data?.OemNo
        }/dealers/`
      : null;

  const {
    data: dealerOptions,
    loading: dealerOptionsLoading,
    error: dealerOptionsError,
    refetch: delaerOpRefetch,
  } = useGet(dealerOptionsUrl);

  const custmerOptionsUrl =
    dealerNo || data?.data?.DealerNo || defaultData?.DealerNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/${
          dealerNo
            ? dealerNo
            : defaultData?.DealerNo
              ? defaultData.DealerNo
              : data?.data?.DealerNo
        }/customers/`
      : hasRole(7, 8, 9) && userData?.dealer_no
        ? `${process.env.REACT_APP_API_URL}/api/dealers/${userData?.dealer_no}/customers/`
        : null;

  const licenseInfoUrl =
    selectedRow[0]?.LicenseNo &&
    `${process.env.REACT_APP_API_URL}/api/licenses/${selectedRow[0]?.LicenseNo}/`;

  const {
    data: custmerOptions,
    loading: custmerOptionsLoading,
    error: custmerOptionsError,
    refetch: customerDataRefetch,
  } = useGet(custmerOptionsUrl);

  const {
    data: postData,
    error: postError,
    postData: postAction,
    loading: postLoading,
  } = usePost(postUrl);
  const {
    data: putData,
    error: putError,
    putData: putAction,
    loading: putLoading,
  } = usePut(putUrl);
  const {
    data: deletedData,
    error: deletedDataError,
    deleteData,
  } = useDelete(deleteUrl);

  const { data: individualLicenseData, error: individualLicenseError } =
    useGet(licenseInfoUrl);

  const modifiedSiteTypes = useMemo(() => {
    const siteTypes = getModifiedResponse(optionsData, "sitetype");
    return siteTypes;
  }, [optionsData]);
  const modifiedSiteTypeOptions = useMemo(
    () =>
      modifiedSiteTypes.map((site) => ({
        ...site,
        icon: siteTypeIconMap[site.value],
        searchLabel: site.label,
      })),
    [modifiedSiteTypes],
  );
  const modifiedProducts = useMemo(
    () => getModifiedResponse(optionsData, "products"),
    [optionsData],
  );
  const modifiedProductOptions = useMemo(
    () =>
      modifiedProducts.map((product) => ({
        ...product,
        icon: productIconMap[product.value],
        searchLabel: product.label,
      })),
    [modifiedProducts],
  );
  const modifiedModels = useMemo(
    () => getModifiedResponse(optionsData, "models"),
    [optionsData],
  );
  const modifiedModelsOptions = useMemo(
    () =>
      modifiedModels.map((model) => ({
        ...model,
        icon: modelIconMap[model.value],
        searchLabel: model.label,
      })),
    [modifiedModels],
  );

  const modifiedOp = useMemo(
    () =>
      optionsData?.data?.options?.map((entry, index) => {
        return {
          value: `${entry?.value}`,
          label: entry.name,
        };
      }),
    [optionsData],
  );

  const handleDoorChange = (e) => {
    const value = e.target.value;
    const doorCount = Number(value);
    const price = calculateDoorPrice(doorCount, licenseType, codesData);
    setDoorPrice(price);
  };

  const handleModelChange = (value) => {
    const price = calculateLicenseTypePrice(
      value,
      form.getFieldValue("LicenseType"),
      codesData,
      modifiedModelsOptions,
    );
    setLicenseTypePrice(price);
  };

  const handleSiteTypeChange = (value) => {
    const price = calculateSiteTypePrice(
      value,
      form.getFieldValue("LicenseType"),
      codesData,
      modifiedSiteTypeOptions,
    );
    setSiteTypePrice(price);
  };

  useEffect(() => {
    const currentDoorValue = form.getFieldValue("Type");
    if (currentDoorValue) {
      const price = calculateDoorPrice(
        currentDoorValue,
        licenseType,
        codesData,
      );
      setDoorPrice(price);
    }
  }, [licenseType, codesData]);

  const handleCreateNew = (type) => {
    setModalType(type);
    setIsOpenModal(true);
  };

  useEffect(() => {
    optionDataRefetch();
    delaerOpRefetch();
    customerDataRefetch();
    if (
      defaultData?.OemNo ||
      defaultData?.DealerNo ||
      defaultData?.CustomerNo
    ) {
      form.setFieldsValue(defaultData);
    }
  }, [defaultData]);

  const modifiedOems = useMemo(
    () => getModifiedResponse(optionsData, "oems"),
    [optionsData],
  );
  const modifiedDealers = useMemo(
    () => getModifiedResponse(dealerOptions, null),
    [dealerOptions],
  );
  const modifiedCustomers = useMemo(
    () => getModifiedResponse(custmerOptions, null),
    [custmerOptions],
  );

  const resolveEffectiveDealerNo = (formFields = {}) =>
    formFields.DealerNo ??
    (id ? data?.data?.DealerNo : null) ??
    (hasRole(7, 8, 9) ? userData?.dealer_no : null) ??
    dealerNo;

  const getDealerMeta = (dealerNoValue) => {
    if (dealerNoValue == null || dealerNoValue === "") {
      return { billingType: null, discountPercent: 0, autoBilling: null };
    }

    const dealerId = Number(dealerNoValue);
    if (!Number.isFinite(dealerId)) {
      return { billingType: null, discountPercent: 0, autoBilling: null };
    }

    const rawDealers = dealerOptions?.data;
    if (!Array.isArray(rawDealers)) {
      return { billingType: null, discountPercent: 0, autoBilling: null };
    }

    const dealer = rawDealers.find(
      (d) =>
        Number(d?.value) === dealerId ||
        Number(d?.DealerNo) === dealerId ||
        Number(d?.dealer_no) === dealerId,
    );

    const bt =
      dealer?.BillingType ??
      dealer?.billing_type ??
      dealer?.billingType ??
      dealer?.Billing_type ??
      null;
    const billingType =
      bt === null || bt === undefined || !Number.isFinite(Number(bt))
        ? null
        : Number(bt);

    const rawDiscount =
      dealer?.discount ??
      dealer?.Discount ??
      dealer?.discount_percent ??
      dealer?.DiscountPercent ??
      0;
    const parsedDiscount = Number(rawDiscount);
    const discountPercent =
      Number.isFinite(parsedDiscount) && parsedDiscount > 0
        ? Math.min(parsedDiscount, 100)
        : 0;

    const autoBilling = normalizeAutoBilling(
      dealer?.auto_billing ??
        dealer?.AutoBilling ??
        dealer?.autobilling ??
        dealer?.autoBilling,
    );

    return { billingType, discountPercent, autoBilling };
  };

  const applyDealerDiscount = (amount, discountPercent) => {
    const amt = Number(amount);
    if (!Number.isFinite(amt) || amt <= 0) return 0;
    const pct = Number(discountPercent);
    if (!Number.isFinite(pct) || pct <= 0) return Number(amt.toFixed(2));
    return Number((amt * (1 - pct / 100)).toFixed(2));
  };

  const summaryDealerDiscountPercent = (() => {
    const currentFields = form.getFieldsValue(true);
    const effectiveDealerNo = resolveEffectiveDealerNo(currentFields);
    return getDealerMeta(effectiveDealerNo).discountPercent;
  })();

  const handleConfirmSubmit = async () => {
    try {
      const formFields = form.getFieldsValue(true);
      const effectiveDealerNo = resolveEffectiveDealerNo(formFields);
      const hasDealerForPayment =
        effectiveDealerNo != null && effectiveDealerNo !== "";

      // Dealer BillingType gating:
      // - BillingType === 1 => allow "Make Payment" popup when amount increases
      // - BillingType === 0 => skip payment popup and directly save (resume previous behavior)
      const {
        billingType: dealerBillingType,
        discountPercent,
        autoBilling,
      } = getDealerMeta(effectiveDealerNo);

      // AutoBilling + no cards → Payment Method (dealers only; admins lack cards API)
      if (hasDealerForPayment && autoBilling === 1 && !isSystemUser) {
        let hasCards = false;
        try {
          hasCards = await fetchDealerHasSavedCards(effectiveDealerNo);
        } catch {
          hasCards = false;
        }
        if (!hasCards) {
          setCardsModalDealerNo(effectiveDealerNo);
          setShowSummaryModal(false);
          setShowCardsModal(true);
          return;
        }
      }

      const shouldShowPaymentModal =
        hasDealerForPayment &&
        (dealerBillingType == null ? true : dealerBillingType === 1);

      const optionsArray = applyExpiredToOptions(
        Object.entries(licenseOptionsData)
          .filter(
            ([_, val]) => val.type === "toggle" && val.enabled && val.value,
          )
          .map(([_, val]) => Number(val.value)),
        form.getFieldValue("Expired"),
      );

      // Extract field values (quantities) from licenseOptionsData
      const fieldValues = {};
      Object.entries(licenseOptionsData).forEach(([key, val]) => {
        if ((val.type === "input" || val.type === "select") && val.fieldName) {
          // Convert quantity to number for numeric fields
          const quantity = Number(val.quantity);
          fieldValues[val.fieldName] = isNaN(quantity)
            ? val.quantity
            : quantity;
        }
      });

      // Build the final payload
      const payload = {
        ...formValuesData,
        ...fieldValues,
        Options: optionsArray,
        Sicucom:
          fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
            ? Number(fieldValues.Sicucom)
            : 0,
        // Temporary behavior: on edit/update requests always send Facegate as 0.
        Facegate: 0,
        // Landline card value is saved as Intercom
        Intercom:
          fieldValues.Intercom != null && fieldValues.Intercom !== ""
            ? Number(fieldValues.Intercom)
            : 0,
        Invitation:
          fieldValues.Invitation != null && fieldValues.Invitation !== ""
            ? Number(fieldValues.Invitation) / 100
            : 0,
      };

      const currentTotal = calculateTotals(
        licenseOptionsData,
        licenseTypePrice,
        doorPrice,
        siteTypePrice,
      );

      // Check if editing or creating
      if (id) {
        const originalTotal = originalLicenseData
          ? calculateTotals(
              originalLicenseData.optionsData || {},
              originalLicenseData.licenseTypePrice || 0,
              originalLicenseData.doorPrice || 0,
              originalLicenseData.siteTypePrice || 0,
            )
          : 0;
        const increasedAmount = Number(
          Math.max(currentTotal - originalTotal, 0).toFixed(2),
        );
        const discountedIncreasedAmount = applyDealerDiscount(
          increasedAmount,
          discountPercent,
        );

        // If edited license price increased, collect payment first — only when a dealer can be billed.
        if (discountedIncreasedAmount > 0 && shouldShowPaymentModal) {
          setPendingSubmitMode("edit");
          setPendingUpdatePayload(payload);
          setPriceChangeAmount(discountedIncreasedAmount);
          setShowSummaryModal(false);
          setPaymentModal(true);
          return;
        }

        // Edit mode — no payment modal (no increase, no dealer, or zero due): update directly.
        await putAction(payload);
      } else {
        const addAmount = Number(Math.max(currentTotal, 0).toFixed(2));

        // Add flow: payment only when there is an amount and a dealer to bill.
        if (addAmount > 0 && shouldShowPaymentModal) {
          setPendingSubmitMode("create");
          setPendingUpdatePayload(payload);
          setPriceChangeAmount(addAmount);
          setShowSummaryModal(false);
          setPaymentModal(true);
          return;
        }

        await postAction(payload);
      }

      // Close the modal
      setShowSummaryModal(false);
      setOriginalLicenseData(null);
    } catch (error) {
      console.error("Submission error:", error);
      openErrorNotification(
        id ? "Failed to edit site." : "Failed to create site.",
      );
    }
  };
  const isValidNvrLicenseConfiguration = () => {
    const channel = licenseOptionsData["Channel"];
    const hasMultipleChannels = channel && channel.quantity >= 1;

    if (!hasMultipleChannels) {
      return true; // No validation needed if Channel quantity is 1 or less
    }

    // Check if at least one of the required options is present and enabled
    const requiredOptions = [
      "Luma NVR",
      "Vitek NVR",
      "Thumb Drive NVR",
      "Speco NVR",
      "DW Spectrum",
    ];

    const hasRequiredOption = requiredOptions.some((optionName) => {
      const option = licenseOptionsData[optionName];
      return option && option.enabled === true;
    });

    return hasRequiredOption;
  };
  const isValidMobileLicenseConfiguration = () => {
    const mobCred = licenseOptionsData["Mobile Credential"];
    const hasMultipleMobCred = mobCred && mobCred.quantity >= 1;

    if (!hasMultipleMobCred) {
      return true;
    }
    // Check if at least one of the required options is present and enabled
    const requiredOptions = [
      "Sicunet Mobile",
      "Wavelynx Mobile",
      "Farpointe Mobile",
    ];

    const hasRequiredOption = requiredOptions.some((optionName) => {
      const option = licenseOptionsData[optionName];
      return option && option.enabled === true;
    });

    return hasRequiredOption;
  };

  const onFinish = async (values) => {
    try {
      if (values.Email != null) {
        values.Email = normalizeEmailValue(values.Email);
      }
      if (id) {
        const optionsArray = applyExpiredToOptions(
          Object.entries(licenseOptionsData)
            .filter(
              ([_, val]) => val.type === "toggle" && val.enabled && val.value,
            )
            .map(([_, val]) => Number(val.value)),
          values?.Expired,
        );

        // Extract field values from optionsData
        const fieldValues = {};
        Object.entries(licenseOptionsData).forEach(([key, val]) => {
          if (
            (val.type === "input" || val.type === "select") &&
            val.fieldName
          ) {
            fieldValues[val.fieldName] = val.quantity;
          }
        });
        const modifiedValue = {
          ...values,
          ...fieldValues,
          DealerNo: values?.DealerNo
            ? values?.DealerNo
            : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
              ? data?.data?.DealerNo
              : null,
          CustomerNo: values?.CustomerNo
            ? values?.CustomerNo
            : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
              ? data?.data?.CustomerNo
              : null,
          OemNo: values?.OemNo
            ? values?.OemNo
            : ![1, 2, 3].includes(userData?.role_value)
              ? data?.data?.OemNo
              : null,
          DeviceDesc: values?.DeviceDesc,
          UserId: values?.UserId,
          Password: values?.Password,
          AutoLogin: values?.AutoLogin,
          Options: optionsArray,
          Type: Number(values.Type),
          // Channel: values.Channel || 0,
          // Lockset: values.Lockset || 0,
          // ContLock: values.ContLock || 0,
          // Facegate: values.Facegate || 0,
          // Subnode: values.Subnode || 0,
          // Intercom: values.Intercom || 0,
          Sicucom:
            fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
              ? Number(fieldValues.Sicucom)
              : 0,
          Invitation:
            fieldValues.Invitation != null && fieldValues.Invitation !== ""
              ? Number(fieldValues.Invitation) / 100
              : 0,
        };
        if (!isValidNvrLicenseConfiguration()) {
          return openErrorNotification("At Least one NVR must be selected");
        }
        if (!isValidMobileLicenseConfiguration()) {
          return openErrorNotification(
            "At Least one Mobile Credential must be selected",
          );
        }
        // await putAction(modifiedValue);

        // Merge everything for the modal
        const mergedData = {
          ...values,
          ...fieldValues,
          Options: optionsArray,
          DealerNo: values?.DealerNo
            ? values?.DealerNo
            : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
              ? data?.data?.DealerNo
              : null,
          CustomerNo: values?.CustomerNo
            ? values?.CustomerNo
            : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
              ? data?.data?.CustomerNo
              : null,
          OemNo: values?.OemNo
            ? values?.OemNo
            : ![1, 2, 3].includes(userData?.role_value)
              ? data?.data?.OemNo
              : null,
          DeviceDesc: values?.DeviceDesc,
          UserId: values?.UserId,
          Password: values?.Password,
          AutoLogin: values?.AutoLogin,
          Options: optionsArray,
          Type: Number(values.Type),
          // Channel: values.Channel || 0,
          // Lockset: values.Lockset || 0,
          // ContLock: values.ContLock || 0,
          // Facegate: values.Facegate || 0,
          // Subnode: values.Subnode || 0,
          // Intercom: values.Intercom || 0,
          Sicucom:
            fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
              ? Number(fieldValues.Sicucom)
              : 0,
          Invitation:
            fieldValues.Invitation != null && fieldValues.Invitation !== ""
              ? Number(fieldValues.Invitation) / 100
              : 0,
        };
        // Store merged data and show summary modal
        setFormValuesData(modifiedValue);
        setPendingFormData(mergedData);
        setShowSummaryModal(true);
      } else {
        if (!isValidNvrLicenseConfiguration()) {
          return openErrorNotification("At Least one NVR must be selected");
        }
        if (!isValidMobileLicenseConfiguration()) {
          return openErrorNotification(
            "At Least one Mobile Credential must be selected",
          );
        }
        const optionsArray = applyExpiredToOptions(
          Object.entries(licenseOptionsData)
            .filter(
              ([_, val]) => val.type === "toggle" && val.enabled && val.value,
            )
            .map(([_, val]) => Number(val.value)),
          values?.Expired,
        );

        // Extract field values from optionsData
        const fieldValues = {};
        Object.entries(licenseOptionsData).forEach(([key, val]) => {
          if (
            (val.type === "input" || val.type === "select") &&
            val.fieldName
          ) {
            fieldValues[val.fieldName] = val.quantity;
          }
        });
        const modifiedValue = {
          ...values,
          ...fieldValues,
          LicenseNo: selectedRow?.[0]?.LicenseNo,
          Options: optionsArray,
          Type: Number(values.Type),
          Channel: fieldValues.Channel ?? values.Channel ?? 0,
          Lockset: fieldValues.Lockset ?? values.Lockset ?? 0,
          ContLock: fieldValues.ContLock ?? values.ContLock ?? 0,
          // Temporary: always send Facegate as 0 on add flow.
          Facegate: 0,
          Subnode: fieldValues.Subnode ?? values.Subnode ?? 0,
          // Landline card value is saved as Intercom
          Intercom:
            fieldValues.Intercom != null && fieldValues.Intercom !== ""
              ? Number(fieldValues.Intercom)
              : values.Intercom != null && values.Intercom !== ""
                ? Number(values.Intercom)
                : 0,
          Sicucom:
            fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
              ? Number(fieldValues.Sicucom)
              : values.Sicucom != null && values.Sicucom !== ""
                ? Number(values.Sicucom)
                : 0,
          Invitation:
            fieldValues.Invitation != null && fieldValues.Invitation !== ""
              ? Number(fieldValues.Invitation) / 100
              : values.Invitation
                ? values.Invitation / 100
                : 0,
          NodeType: 1,
          DealerNo: values?.DealerNo
            ? values?.DealerNo
            : hasRole(7, 8, 9)
              ? userData?.dealer_no
              : null,
          OemNo: values?.OemNo
            ? values?.OemNo
            : hasRole(7, 8, 9)
              ? userData?.oem_no
              : null,
        };
        const mergedData = {
          ...modifiedValue,
          ...fieldValues,
          Options: optionsArray,
          Type: Number(values.Type),
          Sicucom:
            fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
              ? Number(fieldValues.Sicucom)
              : 0,
          Invitation:
            fieldValues.Invitation != null && fieldValues.Invitation !== ""
              ? Number(fieldValues.Invitation) / 100
              : 0,
        };

        // Store merged data and show summary modal
        setFormValuesData(modifiedValue);
        setPendingFormData(mergedData);
        setShowSummaryModal(true);
        // await postAction(modifiedValue);
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
      console.log(error);
    }
  };

  const onReset = () => {
    // setLicenseType(0);
    navigate(-1);
  };

  useEffect(() => {
    if (!paymentModal) setShowCardLayout(!isSystemUser);
  }, [paymentModal, isSystemUser]);

  const onDeleteConfirm = async () => {
    try {
      await deleteData();
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
  };

  // Set default field value for create not a valid undefined field
  useEffect(() => {
    setLicenseType(orderTypeOptions[0].value);
    if (!id) {
      form.setFieldsValue({
        // OemNo: modifiedOems[0]?.value,
        // Product: modifiedProducts[0]?.value,
        Model: modifiedModelsOptions[0]?.value,
        LicenseType: orderTypeOptions[0].value,
      });
    }
  }, [optionsData]);

  useEffect(() => {
    if (!id && optionsData?.data && codesData?.data) {
      const price = calculateLicenseTypePrice(
        modifiedModelsOptions[0]?.value,
        orderTypeOptions[0].value,
        codesData,
        modifiedModelsOptions,
      );
      const siteTypeprice = calculateSiteTypePrice(
        modifiedSiteTypes[0]?.value,
        orderTypeOptions[0].value,
        codesData,
        modifiedSiteTypes,
      );
      setLicenseTypePrice(price);
      setSiteTypePrice(siteTypeprice);
    }
  }, [optionsData, codesData, id]);

  useEffect(() => {
    if (
      !id ||
      loading ||
      !codesData?.data ||
      !modifiedOp ||
      !modifiedModelsOptions?.length ||
      !modifiedOpLicense ||
      !modifiedSiteTypes?.length
    )
      return;
    const getDeviceInfoById = () => {
      try {
        form.resetFields();
        if (data?.data) {
          const currentSiteType = data.data.SiteType;
          let initialLicenseType;

          if ([0, 1, 2].includes(currentSiteType)) {
            initialLicenseType = orderTypeOptions[1].value; // lifetime
          } else if ([3, 4].includes(currentSiteType)) {
            initialLicenseType = orderTypeOptions[0].value; // Monthly
          } else {
            initialLicenseType = 0; // default
          }
          setLicenseType(initialLicenseType);

          form.setFieldsValue({
            DeviceDesc: data?.data?.DeviceDesc || "",
            UserId: data?.data?.UserId || "",
            Password: data?.data?.Password,
            AutoLogin: data?.data?.AutoLogin,
            Blocked: data?.data?.Blocked || 0,
            DeviceName: data?.data?.DeviceName || "",
            DealerNo: data?.data?.DealerNo,
            CustomerNo: data?.data?.CustomerNo,
            SiteType: data?.data?.SiteType,
            Type: data?.data?.Type || 0,
            AddTime: data?.data?.AddTime
              ? new Date(data.data.AddTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            ActTime: data?.data?.ActTime
              ? new Date(data.data.ActTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            StartTime: data?.data?.StartTime
              ? new Date(data.data.StartTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            EndTime: data?.data?.EndTime
              ? new Date(data.data.EndTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            Mac: data?.data?.Mac || "",
            SiteKey: data?.data?.SiteKey || "",
            LicenseKey: data?.data?.LicenseKey || "",
            // Address: data?.data?.Address || "",
            ProxyServer: data?.data?.ProxyAddr,
            SecurePort: data?.data?.SecurePort
              ? String(data?.data?.SecurePort)
              : "",
            DebugPort: data?.data?.DebugPort
              ? String(data?.data?.DebugPort)
              : "",
            Version: data?.data?.Version ? String(data?.data?.Version) : "",
            Https: data?.data?.Https ? "Yes" : "No",
            Timezone: data?.data?.Timezone ? String(data?.data?.Timezone) : "",
            Online: data?.data?.Online ? "Yes" : "No",
            Product: data?.data?.Product,
            Model: data?.data?.Model,
            OemNo: data?.data?.OemNo,
            Options: data.data.Options?.map((item) => String(item)),
            Channel: data?.data?.Channel,
            Lockset: data?.data?.Lockset,
            Facegate: data?.data?.Facegate,
            Subnode: data?.data?.Subnode,
            ContLock: data?.data?.ContLock,
            Intercom: data?.data?.Intercom,
            Sicucom:
              data.data.Sicucom != null ? Number(data.data.Sicucom) : null,
            Invitation: data.data.Invitation
              ? data.data.Invitation * 100
              : null,
            FirstName: data?.data?.FirstName
              ? String(data?.data?.FirstName)
              : "",
            LastName: data?.data?.LastName ? String(data?.data?.LastName) : "",
            Company: data?.data?.Company ? String(data?.data?.Company) : "",
            Email: data?.data?.Email ? String(data?.data?.Email) : "",
            Phone: data?.data?.Phone ? String(data?.data?.Phone) : "",
            Address: data?.data?.Address ? String(data?.data?.Address) : "",
            Address2: data?.data?.Address2 ? String(data?.data?.Address2) : "",
            InstallType: data?.data?.InstallType
              ? String(data?.data?.InstallType)
              : "",
            Suggestion: data?.data?.Suggestion
              ? String(data?.data?.Suggestion)
              : "",
            LicenseType: initialLicenseType,
            Expired: data.data.Options?.includes(64) ?? false,
            // Storage: data?.data?.Storage,
          });
          const reconstructedOptionsData = {};

          // Handle toggle options (from Options array)
          if (data.data.Options && modifiedOpLicense) {
            data.data.Options.forEach((optionValue) => {
              const option = modifiedOpLicense.find(
                (opt) => opt.value === String(optionValue),
              );
              if (option) {
                const itemNo = getItemNoByLabel(option.label);
                reconstructedOptionsData[option.label] = {
                  type: "toggle",
                  enabled: true,
                  value: option.value,
                  itemNo: itemNo,
                  price: getPrice(
                    option.label,
                    codesData,
                    initialLicenseType,
                    1,
                    itemNo,
                  ),
                };
              }
            });
          }

          // Handle input/select options
          const inputFields = [
            { label: "Channel", fieldName: "Channel", type: "input" },
            { label: "Lockset", fieldName: "Lockset", type: "input" },
            { label: "Trilogy Lockset", fieldName: "ContLock", type: "input" },
            { label: "Facegate", fieldName: "Facegate", type: "input" },
            { label: "OSDP Door", fieldName: "Subnode", type: "input" },
            { label: "Landline", fieldName: "Intercom", type: "select" },
            {
              label: "Unit",
              fieldName: "Sicucom",
              type: "input",
            },
            {
              label: "Mobile Credential",
              fieldName: "Invitation",
              type: "select",
            },
          ];

          inputFields.forEach(({ label, fieldName, type: cardType }) => {
            const value = data.data[fieldName];
            if (value && value > 0) {
              const quantity = fieldName === "Invitation" ? value * 100 : value;

              const option = modifiedOp?.find((opt) => opt.label === label);
              const itemNo = getItemNoByLabel(label);

              reconstructedOptionsData[label] = {
                type: cardType,
                quantity: quantity,
                fieldName: fieldName,
                value: option?.value || null,
                itemNo: itemNo,
                price:
                  fieldName === "Intercom"
                    ? Number(data.data.IntercomPrice ?? 0) || 0
                    : getPrice(
                        label,
                        codesData,
                        initialLicenseType,
                        quantity,
                        itemNo,
                      ),
              };
            }
          });

          setLicenseOptionsData(reconstructedOptionsData);

          setDefaultData((prev) => ({
            ...prev,
            OemNo: data?.data?.OemNo || null,
            DealerNo: data?.data?.DealerNo || null,
            CustomerNo: data?.data?.CustomerNo || null,
          }));
          setAutoLogin(data?.data?.AutoLogin);

          setSiteType(data.data.SiteType || 0);
          // Calculate and set prices
          const price = calculateLicenseTypePrice(
            data.data.Model,
            initialLicenseType,
            codesData,
            modifiedModelsOptions,
          );

          const siteTypeprice = calculateSiteTypePrice(
            data.data.SiteType,
            initialLicenseType,
            codesData,
            modifiedSiteTypes,
          );
          setSiteTypePrice(siteTypeprice);

          const doorPrice = calculateDoorPrice(
            data.data.Type,
            initialLicenseType,
            codesData,
          );
          setDoorPrice(doorPrice);

          setLicenseTypePrice(price);
          if (id && type === "edit") {
            setOriginalLicenseData({
              Model: data?.data?.Model,
              Type: data?.data?.Type,
              SiteType: data?.data?.SiteType,
              licenseTypePrice: price,
              siteTypePrice: siteTypeprice,
              doorPrice: doorPrice,
              optionsData: { ...reconstructedOptionsData },
            });
          }
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        console.log({ error });
        openErrorNotification("Error fetching data!");
      }
    };

    getDeviceInfoById();
  }, [
    id,
    type,
    data,
    loading,
    codesData,
    modifiedOp,
    modifiedModelsOptions,
    modifiedOpLicense,
    modifiedSiteTypes,
  ]);

  useEffect(() => {
    if (!type && searchData) {
      if (searchData?.data.length) {
        const data = searchData?.data?.[0];

        form.setFieldsValue({
          DeviceName: data?.DeviceName || "",
          SiteType: data?.SiteType,
          Mac: data?.Mac,
          SiteKey: data?.SiteKey,
          LicenseKey: data?.LicenseKey,
        });
      } else if (!searchData?.data.length) {
        openErrorNotification("No Site Found");
      }
    }
  }, [type, searchData]);

  // Set default field value
  useEffect(() => {
    if (!id) {
      form.setFieldsValue({
        Product: modifiedProductOptions[0]?.value,
        Model: modifiedModelsOptions[0]?.value,
        Options: [],
        SiteType: hasRole(7, 8, 9)
          ? modifiedSiteTypeOptions[3]?.value
          : modifiedSiteTypeOptions[0]?.value,
      });
      if (hasRole(7, 8, 9)) {
        setSiteType(3);
      }
    }
  }, [optionsData]);

  useEffect(() => {
    if (data?.data?.SiteType && !form.getFieldValue("DealerNo")) {
      if (data?.data?.SiteType === 3 && type === "edit") {
        return;
      }
      if (id) {
        return;
      }
      form.setFieldsValue({
        SiteType: hasRole(7, 8, 9) ? data?.data?.SiteType : 0,
      });
    }
  }, [form.getFieldValue("DealerNo")]);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong",
      );
    } else if (!postError && postData) {
      if (paymentFlowInProgressRef.current) {
        // Save happens before payment; don't navigate/toast yet.
        return;
      }
      if (isPaymentTriggeredApiRef.current) {
        isPaymentTriggeredApiRef.current = false;
        if (id) {
          navigate(`/site/info/${id}`);
        } else {
          navigate(-1);
        }
        return;
      }

      openConfirmNotification("Success");
      navigate(-1);
    }
  }, [postError, postData]);

  //toat for update
  useEffect(() => {
    if (putError) {
      if (giftCardAwaitingSitePutRef.current) {
        giftCardAwaitingSitePutRef.current = false;
        pendingGiftCardMarkUsedPayloadRef.current = null;
      }
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong",
      );
    } else if (!putError && putData) {
      refetch();
      // setLicenseType(0);
      if (skipNextSitePutSuccessRef.current) {
        skipNextSitePutSuccessRef.current = false;
        return;
      }
      if (isPaymentTriggeredApiRef.current) {
        isPaymentTriggeredApiRef.current = false;
        if (id) navigate(`/site/info/${id}`);
        return;
      }
      if (paymentFlowInProgressRef.current) {
        // Save happens before payment; don't navigate/toast yet.
        if (giftCardAwaitingSitePutRef.current) {
          giftCardAwaitingSitePutRef.current = false;
          const pending = pendingGiftCardMarkUsedPayloadRef.current;
          pendingGiftCardMarkUsedPayloadRef.current = null;
          if (pending) {
            giftCardPostAction(pending);
          }
        }
        return;
      }
      if (giftCardAwaitingSitePutRef.current) {
        giftCardAwaitingSitePutRef.current = false;
        const pending = pendingGiftCardMarkUsedPayloadRef.current;
        pendingGiftCardMarkUsedPayloadRef.current = null;
        if (pending) {
          giftCardPostAction(pending);
        }
      }
      // if ([1, 2].includes(userData?.role_value)) {
      openConfirmNotification("Success");
      navigate(-1);
      // navigate("/site");
      // }
    }
  }, [putData, putError]);

  //toast for delete
  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      navigate("/site");
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong",
      );
    } else {
      return;
    }
  }, [deletedData, deletedDataError]);

  useEffect(() => {
    const currentSiteType = form.getFieldValue("SiteType");

    if (currentSiteType === undefined) return;
    if (id && loading) return;
    let newLicenseType;

    if ([0, 1, 2].includes(currentSiteType)) {
      newLicenseType = orderTypeOptions[1].value; // lifetime
    } else if ([3, 4].includes(currentSiteType)) {
      newLicenseType = orderTypeOptions[0].value; // Monthly
    }

    if (newLicenseType === undefined) return;

    // Update regardless of previous value to handle page transitions
    setLicenseType(newLicenseType);
    form.setFieldsValue({ LicenseType: newLicenseType });

    // Recalculate prices with the new license type
    const price = calculateLicenseTypePrice(
      form.getFieldValue("Model"),
      newLicenseType,
      codesData,
      modifiedModelsOptions,
    );
    const siteTypeprice = calculateSiteTypePrice(
      currentSiteType,
      newLicenseType,
      codesData,
      modifiedSiteTypes,
    );
    const doorPriceValue = calculateDoorPrice(
      form.getFieldValue("Type"),
      newLicenseType,
      codesData,
    );

    setLicenseTypePrice(price);
    setSiteTypePrice(siteTypeprice);
    setDoorPrice(doorPriceValue);
  }, [
    sitetype,
    codesData,
    modifiedModelsOptions,
    modifiedSiteTypes,
    type,
    data,
  ]);

  useEffect(() => {
    if (data?.data?.SiteType === 3 && type === "edit") {
      return;
    }
    if (!form.getFieldValue("DealerNo") && !id) {
      form.setFieldsValue({
        SiteType: hasRole(7, 8, 9) ? 3 : 0,
      });
    } else if (
      form.getFieldValue("DealerNo") &&
      licenseSiteType &&
      type !== "edit" &&
      type !== "info"
    ) {
      form.setFieldsValue({
        SiteType: licenseSiteType,
      });
    }
  }, [form.getFieldValue("DealerNo"), form.getFieldValue("OemNo")]);

  const breadcrumbItems = [
    {
      label: "Site",
      href: "/site",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: id
        ? type === "info"
          ? `/site/info/${id}`
          : `/site/edit/${id}`
        : "/site/add",
    },
  ];

  const applyGiftCardRowToSite = (row) => {
    if (!id || !row) {
      return;
    }

    if (row.GiftCardItems?.length) {
      const valuesBeforeMerge = form.getFieldsValue(true);
      const validation = validateGiftCardItemsOldCodeMatchesForm(
        row.GiftCardItems,
        codesData,
        valuesBeforeMerge,
        "site",
      );
      if (!validation.ok) {
        openErrorNotification(validation.message, 12);
        giftCardAwaitingSitePutRef.current = false;
        pendingGiftCardMarkUsedPayloadRef.current = null;
        return;
      }

      const merged = mergeGiftCardItemsState(
        row.GiftCardItems,
        codesData,
        valuesBeforeMerge,
      );
      if (!merged) {
        giftCardAwaitingSitePutRef.current = false;
        pendingGiftCardMarkUsedPayloadRef.current = null;
        return;
      }

      const values = form.getFieldsValue(true);
      const siteTypeVal =
        merged.formPatch.SiteType ?? values.SiteType ?? data?.data?.SiteType;
      const resolvedLt =
        resolveLicenseTypeFromSiteType(siteTypeVal, orderTypeOptions) ??
        values.LicenseType ??
        data?.data?.LicenseType ??
        0;

      // Only enrich from what THIS gift row applies. Using existing form/API
      // Invitation/Channel here incorrectly force-enables Credential Invitation
      // (and NVR children) when the prepurchased item is only e.g. Gemini.
      const channelForEnrich =
        merged.formPatch.Channel != null ? merged.formPatch.Channel : 0;
      const invitationForEnrich =
        merged.formPatch.Invitation != null ? merged.formPatch.Invitation : 0;

      const currentToggleOptions = Object.entries(licenseOptionsData)
        .filter(([_, val]) => val.type === "toggle" && val.enabled && val.value)
        .map(([_, val]) => Number(val.value));

      let giftOptions = enrichGiftCardOptionsWithChannelMobileChildren(
        merged.optionsArray,
        channelForEnrich,
        invitationForEnrich,
      );
      let optionsArray = applyExpiredToOptions(
        [...new Set([...currentToggleOptions, ...giftOptions])],
        form.getFieldValue("Expired"),
      );

      const nextValues = {
        ...values,
        ...merged.formPatch,
        LicenseType: resolvedLt,
        Options: optionsArray.map(String),
      };
      form.setFieldsValue(nextValues);

      setLicenseOptionsData((prev) => {
        const next = { ...prev };
        if (modifiedOpLicense) {
          optionsArray.forEach((num) => {
            if (num === 64) return;
            const opt = modifiedOpLicense.find((o) => Number(o.value) === num);
            if (opt) {
              const itemNo = getItemNoByLabel(opt.label);
              next[opt.label] = {
                type: "toggle",
                enabled: true,
                value: opt.value,
                itemNo: itemNo,
                price: getPrice(opt.label, codesData, resolvedLt, 1, itemNo),
              };
            }
          });
        }
        return next;
      });

      if (merged.formPatch.SiteType != null) {
        setSiteType(merged.formPatch.SiteType);
      }
      setLicenseType(resolvedLt);

      const model =
        merged.formPatch.Model ?? nextValues.Model ?? data?.data?.Model;
      const stForPrice =
        merged.formPatch.SiteType ??
        nextValues.SiteType ??
        data?.data?.SiteType;
      const doorVal =
        merged.formPatch.Type ?? nextValues.Type ?? data?.data?.Type;

      setLicenseTypePrice(
        calculateLicenseTypePrice(
          model,
          resolvedLt,
          codesData,
          modifiedModelsOptions,
        ),
      );
      setSiteTypePrice(
        calculateSiteTypePrice(stForPrice, resolvedLt, codesData),
      );
      setDoorPrice(calculateDoorPrice(doorVal, resolvedLt, codesData));

      const sicucom =
        merged.formPatch.Sicucom != null
          ? Number(merged.formPatch.Sicucom)
          : nextValues.Sicucom != null
            ? Number(nextValues.Sicucom)
            : (data?.data?.Sicucom ?? 0);
      const invitation =
        merged.formPatch.Invitation != null
          ? merged.formPatch.Invitation / 100
          : nextValues.Invitation != null
            ? Number(nextValues.Invitation) / 100
            : (data?.data?.Invitation ?? 0);

      const payload = {
        Expired: form.getFieldValue("Expired") ?? false,
        LicenseType: resolvedLt,
        DeviceName: nextValues?.DeviceName ?? data?.data?.DeviceName ?? "",
        DeviceDesc: nextValues?.DeviceDesc ?? data?.data?.DeviceDesc ?? "",
        OemNo: nextValues?.OemNo
          ? nextValues.OemNo
          : ![1, 2, 3].includes(userData?.role_value)
            ? data?.data?.OemNo
            : null,
        DealerNo: nextValues?.DealerNo
          ? nextValues.DealerNo
          : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
            ? data?.data?.DealerNo
            : null,
        CustomerNo: nextValues?.CustomerNo
          ? nextValues.CustomerNo
          : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
            ? data?.data?.CustomerNo
            : null,
        SiteType: nextValues?.SiteType ?? data?.data?.SiteType,
        Product: nextValues?.Product ?? data?.data?.Product ?? 0,
        Mac: nextValues?.Mac ?? data?.data?.Mac ?? "",
        Model: nextValues?.Model ?? data?.data?.Model ?? 0,
        Type: Number(nextValues?.Type ?? data?.data?.Type ?? 0),
        AutoLogin: nextValues?.AutoLogin ?? data?.data?.AutoLogin ?? 0,
        Blocked: nextValues?.Blocked ?? data?.data?.Blocked ?? 0,
        Options: optionsArray,
        Channel:
          merged.formPatch.Channel ??
          nextValues.Channel ??
          data?.data?.Channel ??
          0,
        Lockset:
          merged.formPatch.Lockset ??
          nextValues.Lockset ??
          data?.data?.Lockset ??
          0,
        ContLock:
          merged.formPatch.ContLock ??
          nextValues.ContLock ??
          data?.data?.ContLock ??
          0,
        // Temporary behavior: on edit/update requests always send Facegate as 0.
        Facegate: 0,
        Subnode:
          merged.formPatch.Subnode ??
          nextValues.Subnode ??
          data?.data?.Subnode ??
          0,
        // Landline card value is saved as Intercom
        Intercom: nextValues.Intercom ?? data?.data?.Intercom ?? 0,
        Sicucom: sicucom,
        Invitation: invitation,
        is_prepurchased: true,
      };

      putAction(payload);
      return;
    }

    const itemNo = getItemNoByLabel(row.Item);
    const values = form.getFieldsValue(true);

    const codeValue = getCodeValueForGiftCard(
      itemNo,
      row.CodeName,
      row.Code,
      codesData,
    );

    if (itemNo === 1) values.SiteType = codeValue;
    else if (itemNo === 2) values.Model = codeValue;
    else if (itemNo === 3) values.Type = codeValue;

    form.setFieldsValue(values);

    let optionsArray = Object.entries(licenseOptionsData)
      .filter(([_, val]) => val.type === "toggle" && val.enabled && val.value)
      .map(([_, val]) => Number(val.value));
    if (optionsArray.length === 0 && data?.data?.Options?.length) {
      optionsArray = [...data.data.Options];
    }
    const licenseOpt = licenseOptions.find(
      (o) => o.label?.toLowerCase() === row.Item?.toLowerCase(),
    );
    if (licenseOpt != null) {
      const optionValue = Number(licenseOpt.value);
      if (!optionsArray.includes(optionValue)) optionsArray.push(optionValue);
    }
    optionsArray = applyExpiredToOptions(
      optionsArray,
      form.getFieldValue("Expired"),
    );

    const fieldValues = {};
    Object.entries(licenseOptionsData).forEach(([key, val]) => {
      if ((val.type === "input" || val.type === "select") && val.fieldName) {
        const quantity = Number(val.quantity);
        fieldValues[val.fieldName] = isNaN(quantity) ? val.quantity : quantity;
      }
    });
    const inputOpt = inputCardOptions.find(
      (opt) => opt.label?.toLowerCase() === row.Item?.toLowerCase(),
    );
    if (inputOpt?.fieldName) {
      const isInvitationHundredths = inputOpt.fieldName === "Invitation";
      fieldValues[inputOpt.fieldName] = isInvitationHundredths
        ? Number(codeValue) * 100
        : Number(codeValue);
    }

    const sicucom =
      fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
        ? Number(fieldValues.Sicucom)
        : 0;
    const invitation = fieldValues.Invitation
      ? fieldValues.Invitation / 100
      : 0;

    const channelVal = fieldValues.Channel ?? data?.data?.Channel ?? 0;
    const invitationVal = fieldValues.Invitation ?? data?.data?.Invitation ?? 0;
    optionsArray = enrichGiftCardOptionsWithChannelMobileChildren(
      optionsArray,
      channelVal,
      invitationVal,
    );

    const payload = {
      Expired: form.getFieldValue("Expired") ?? false,
      LicenseType: values?.LicenseType ?? data?.data?.LicenseType ?? 0,
      DeviceName: values?.DeviceName ?? data?.data?.DeviceName ?? "",
      DeviceDesc: values?.DeviceDesc ?? data?.data?.DeviceDesc ?? "",
      OemNo: values?.OemNo
        ? values.OemNo
        : ![1, 2, 3].includes(userData?.role_value)
          ? data?.data?.OemNo
          : null,
      DealerNo: values?.DealerNo
        ? values.DealerNo
        : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
          ? data?.data?.DealerNo
          : null,
      CustomerNo: values?.CustomerNo
        ? values.CustomerNo
        : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
          ? data?.data?.CustomerNo
          : null,
      SiteType: values?.SiteType ?? data?.data?.SiteType,
      Product: values?.Product ?? data?.data?.Product ?? 0,
      Mac: values?.Mac ?? data?.data?.Mac ?? "",
      Model: values?.Model ?? data?.data?.Model ?? 0,
      Type: Number(values?.Type) ?? data?.data?.Type ?? 0,
      AutoLogin: values?.AutoLogin ?? data?.data?.AutoLogin ?? 0,
      Blocked: values?.Blocked ?? data?.data?.Blocked ?? 0,
      Options: optionsArray,
      Channel: fieldValues.Channel ?? data?.data?.Channel ?? 0,
      Lockset: fieldValues.Lockset ?? data?.data?.Lockset ?? 0,
      ContLock: fieldValues.ContLock ?? data?.data?.ContLock ?? 0,
      // Temporary behavior: on edit/update requests always send Facegate as 0.
      Facegate: 0,
      Subnode: fieldValues.Subnode ?? data?.data?.Subnode ?? 0,
      // Landline card value is saved as Intercom
      Intercom: fieldValues.Intercom ?? data?.data?.Intercom ?? 0,
      Sicucom: sicucom,
      Invitation: invitation,
      is_prepurchased: true,
    };

    putAction(payload);
  };

  useEffect(() => {
    if (giftCardPostError) {
      openErrorNotification(
        giftCardPostError?.response?.data?.message || "Something went wrong",
      );
      prevGiftCardPostLoadingRef.current = giftCardPostLoading;
      return;
    }

    const postJustFinished =
      prevGiftCardPostLoadingRef.current &&
      !giftCardPostLoading &&
      !giftCardPostError &&
      giftCardPostData;

    prevGiftCardPostLoadingRef.current = giftCardPostLoading;

    if (!postJustFinished || !id) return;

    openConfirmNotification("Success");
    setShowGiftCardModal(false);
  }, [giftCardPostError, giftCardPostData, giftCardPostLoading, id]);

  const totalPrice = calculateTotals(
    licenseOptionsData,
    licenseTypePrice,
    doorPrice,
    siteTypePrice,
  );

  const applyLimitedLicenseIntercomUpdate = async (
    licenseCode,
    displayPrice = 0,
  ) => {
    const site = data?.data || {};
    const values = form.getFieldsValue(true);
    let optionsArray = Object.entries(licenseOptionsData)
      .filter(([_, val]) => val.type === "toggle" && val.enabled && val.value)
      .map(([_, val]) => Number(val.value));
    if (optionsArray.length === 0 && site.Options?.length) {
      optionsArray = [...site.Options];
    }
    optionsArray = applyExpiredToOptions(
      optionsArray,
      form.getFieldValue("Expired"),
    );

    const fieldValues = {};
    Object.entries(licenseOptionsData).forEach(([_, val]) => {
      if ((val.type === "input" || val.type === "select") && val.fieldName) {
        fieldValues[val.fieldName] = val.quantity;
      }
    });

    const intercomValue = Number(licenseCode);
    if (!Number.isFinite(intercomValue) || intercomValue < 0) {
      openErrorNotification("Selected limited card has no valid License Code.");
      return false;
    }

    const sitePutPayload = {
      Expired: form.getFieldValue("Expired") ?? false,
      LicenseType: values?.LicenseType ?? site.LicenseType ?? 0,
      DeviceName: values?.DeviceName ?? site.DeviceName ?? "",
      DeviceDesc: values?.DeviceDesc ?? site.DeviceDesc ?? "",
      OemNo: values?.OemNo
        ? values.OemNo
        : ![1, 2, 3].includes(userData?.role_value)
          ? site.OemNo
          : null,
      DealerNo: values?.DealerNo
        ? values.DealerNo
        : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
          ? site.DealerNo
          : null,
      CustomerNo: values?.CustomerNo
        ? values.CustomerNo
        : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
          ? site.CustomerNo
          : null,
      SiteType: values?.SiteType ?? site.SiteType,
      Product: values?.Product ?? site.Product ?? 0,
      Mac: values?.Mac ?? site.Mac ?? "",
      Model: values?.Model ?? site.Model ?? 0,
      Type: Number(values?.Type ?? site.Type ?? 0),
      AutoLogin: values?.AutoLogin ?? site.AutoLogin ?? 0,
      Blocked: values?.Blocked ?? site.Blocked ?? 0,
      Options: optionsArray,
      Channel: fieldValues.Channel ?? site.Channel ?? 0,
      Lockset: fieldValues.Lockset ?? site.Lockset ?? 0,
      ContLock: fieldValues.ContLock ?? site.ContLock ?? 0,
      Facegate: 0,
      Subnode: fieldValues.Subnode ?? site.Subnode ?? 0,
      Intercom: intercomValue,
      Sicucom:
        fieldValues.Sicucom != null && fieldValues.Sicucom !== ""
          ? Number(fieldValues.Sicucom)
          : Number(site.Sicucom ?? 0),
      Invitation:
        fieldValues.Invitation != null && fieldValues.Invitation !== ""
          ? Number(fieldValues.Invitation) / 100
          : Number(site.Invitation ?? 0),
    };

    skipNextSitePutSuccessRef.current = true;
    paymentFlowInProgressRef.current = true;
    const putResult = await putAction(sitePutPayload);
    paymentFlowInProgressRef.current = false;

    if (!putResult) {
      skipNextSitePutSuccessRef.current = false;
      openErrorNotification("Order created but updating Landline failed.");
      return false;
    }

    form.setFieldsValue({ Intercom: intercomValue });
    setLicenseOptionsData((prev) => ({
      ...prev,
      Landline: {
        type: "select",
        quantity: intercomValue,
        price: Number(displayPrice ?? 0) || 0,
        fieldName: "Intercom",
        value: null,
        itemNo: 207,
      },
    }));
    return true;
  };

  const displayPrice =
    Number(
      licenseType === orderTypeOptions[1].value
        ? (() => {
            const originalTotal = originalLicenseData
              ? calculateTotals(
                  originalLicenseData.optionsData || {},
                  originalLicenseData.licenseTypePrice || 0,
                  originalLicenseData.doorPrice || 0,
                  originalLicenseData.siteTypePrice || 0,
                )
              : 0;
            return Math.max(totalPrice - originalTotal, 0);
          })()
        : totalPrice,
    ) || 0;

  const isLifetimeMode = licenseType === orderTypeOptions[1].value;

  const isPriceChanged = (currentPrice, originalPrice) => {
    if (type !== "edit") return false;
    if (!isLifetimeMode) return false;
    return Number(currentPrice) > Number(originalPrice ?? 0);
  };

  const origModelPrice = originalLicenseData?.licenseTypePrice ?? 0;
  const origSiteTypePrice = originalLicenseData?.siteTypePrice ?? 0;
  const origDoorPrice = originalLicenseData?.doorPrice ?? 0;

  const buttonsData =
    type === "info"
      ? [1, 2].includes(userData?.role_value)
        ? [
            ...([0, 1, 2].includes(data?.data?.SiteType)
              ? [
                  {
                    label: "Limited License",
                    icon: <FaCalendarDays />,
                    onClick: () => setShowLimitedLicenseModal(true),
                  },
                ]
              : []),
            {
              name: "Expired",
              label: "Expired",
              toggle: true,
              disabled: true,
            },
            // {
            //   name: "LicenseType",
            //   label: "LicenseType",
            //   radioOptions: orderTypeOptions,
            //   toggle: true,
            //   disabled: true,
            //   onChange: (value) => {
            //     setLicenseType(value);
            //     const price = calculateLicenseTypePrice(
            //       form.getFieldValue("Model"),
            //       value,
            //       codesData,
            //       modifiedModelsOptions,
            //     );
            //     const siteTypeprice = calculateSiteTypePrice(
            //       form.getFieldValue("SiteType"),
            //       value,
            //       codesData,
            //       modifiedSiteTypes,
            //     );
            //     setLicenseTypePrice(price);
            //     setSiteTypePrice(siteTypeprice);
            //   },
            // },
            // {
            //   label: "Total Price: ",
            //   renderLabel: true,
            //   value: `${"$ " + totalPrice}`,
            // },
            {
              label: "Edit",
              icon: <EditOutlined />,
              onClick: () => {
                navigate(`/site/edit/${id}`);
              },
            },
            {
              label: "Delete",
              icon: <DeleteOutlined />,
              onClick: () => {
                setShowModal(true);
              },
            },
            {
              label: "List",
              icon: <UnorderedListOutlined />,
              onClick: () => {
                navigate(-1);
              },
            },
          ]
        : [3, 6, 9].includes(userData?.role_value)
          ? [
              {
                name: "Expired",
                label: "Expired",
                toggle: true,
                disabled: true,
              },
              // {
              //   name: "LicenseType",
              //   label: "LicenseType",
              //   radioOptions: orderTypeOptions,
              //   toggle: true,
              //   disabled: true,
              //   onChange: (value) => {
              //     setLicenseType(value);
              //     const price = calculateLicenseTypePrice(
              //       form.getFieldValue("Model"),
              //       value,
              //       codesData,
              //       modifiedModelsOptions,
              //     );
              //     const siteTypeprice = calculateSiteTypePrice(
              //       form.getFieldValue("SiteType"),
              //       value,
              //       codesData,
              //       modifiedSiteTypes,
              //     );
              //     setLicenseTypePrice(price);
              //     setSiteTypePrice(siteTypeprice);
              //   },
              // },
              // {
              //   label: "Total Price: ",
              //   renderLabel: true,
              //   value: `${"$ " + totalPrice}`,
              // },
              {
                label: "List",
                icon: <UnorderedListOutlined />,
                onClick: () => {
                  navigate(-1);
                },
              },
            ]
          : [4, 5].includes(userData?.role_value)
            ? [
                {
                  name: "Expired",
                  label: "Expired",
                  toggle: true,
                  disabled: true,
                },
                // {
                //   name: "LicenseType",
                //   label: "LicenseType",
                //   radioOptions: orderTypeOptions,
                //   toggle: true,
                //   disabled: true,
                //   onChange: (value) => {
                //     setLicenseType(value);
                //     const price = calculateLicenseTypePrice(
                //       form.getFieldValue("Model"),
                //       value,
                //       codesData,
                //       modifiedModelsOptions,
                //     );
                //     const siteTypeprice = calculateSiteTypePrice(
                //       form.getFieldValue("SiteType"),
                //       value,
                //       codesData,
                //       modifiedSiteTypes,
                //     );
                //     setLicenseTypePrice(price);
                //     setSiteTypePrice(siteTypeprice);
                //   },
                // },
                // {
                //   label: "Total Price: ",
                //   renderLabel: true,
                //   value: `${"$ " + totalPrice}`,
                // },
                {
                  label: "Edit",
                  icon: <EditOutlined />,
                  onClick: () => {
                    navigate(`/site/edit/${id}`);
                  },
                },

                {
                  label: "List",
                  icon: <UnorderedListOutlined />,
                  onClick: () => {
                    navigate(-1);
                  },
                },
              ]
            : [7, 8].includes(userData?.role_value)
              ? [
                  ...([0, 1, 2].includes(data?.data?.SiteType)
                    ? [
                        {
                          label: "Limited License",
                          icon: <FaCalendarDays />,
                          onClick: () => setShowLimitedLicenseModal(true),
                        },
                        {
                          label: "Prepurchased License",
                          icon: <GiftFilled />,
                          onClick: () => setShowGiftCardModal(true),
                        },
                      ]
                    : []),
                  {
                    name: "Expired",
                    label: "Expired",
                    toggle: true,
                    disabled: true,
                  },
                  // {
                  //   name: "LicenseType",
                  //   label: "LicenseType",
                  //   radioOptions: orderTypeOptions,
                  //   toggle: true,
                  //   disabled: true,
                  //   onChange: (value) => {
                  //     setLicenseType(value);
                  //     const price = calculateLicenseTypePrice(
                  //       form.getFieldValue("Model"),
                  //       value,
                  //       codesData,
                  //       modifiedModelsOptions,
                  //     );
                  //     const siteTypeprice = calculateSiteTypePrice(
                  //       form.getFieldValue("SiteType"),
                  //       value,
                  //       codesData,
                  //       modifiedSiteTypes,
                  //     );
                  //     setLicenseTypePrice(price);
                  //     setSiteTypePrice(siteTypeprice);
                  //   },
                  // },
                  // {
                  //   label: "Total Price: ",
                  //   renderLabel: true,
                  //   value: `${"$ " + totalPrice}`,
                  // },
                  {
                    label: "Edit",
                    icon: <EditOutlined />,
                    onClick: () => {
                      navigate(`/site/edit/${id}`);
                    },
                  },
                  {
                    label: "List",
                    icon: <UnorderedListOutlined />,
                    onClick: () => {
                      navigate(-1);
                    },
                  },
                ]
              : [
                  // {
                  //   label: "Total Price: ",
                  //   renderLabel: true,
                  //   value: `${"$ " + totalPrice}`,
                  // },
                  {
                    label: "List",
                    icon: <UnorderedListOutlined />,
                    onClick: () => {
                      navigate(-1);
                    },
                  },
                ]
      : type === "edit"
        ? [
            {
              name: "Expired",
              label: "Expired",
              toggle: true,
              onClick: () => {},
            },
            // {
            //   name: "LicenseType",
            //   label: "LicenseType",
            //   radioOptions: orderTypeOptions,
            //   toggle: true,
            //   disabled: true,
            //   onChange: (value) => {
            //     setLicenseType(value);
            //     const price = calculateLicenseTypePrice(
            //       form.getFieldValue("Model"),
            //       value,
            //       codesData,
            //       modifiedModelsOptions,
            //     );
            //     const siteTypeprice = calculateSiteTypePrice(
            //       form.getFieldValue("SiteType"),
            //       value,
            //       codesData,
            //       modifiedSiteTypes,
            //     );
            //     setLicenseTypePrice(price);
            //     setSiteTypePrice(siteTypeprice);
            //   },
            // },
            {
              label:
                licenseType === orderTypeOptions[0].value
                  ? "Monthly Price: "
                  : "Additional Price: ",
              renderLabel: true,
              value: `$ ${displayPrice.toFixed(2)}`,
            },
            {
              label: "Apply",
              icon: <CheckCircleOutlined />,
              onClick: () => form.submit(),
              loading: putLoading,
            },
            {
              label: "Cancel",
              icon: <CloseOutlined />,
              onClick: onReset,
            },
          ]
        : hasRole(7, 8, 9)
          ? [
              {
                name: "Expired",
                label: "Expired",
                toggle: true,
                onClick: () => {},
              },
              // {
              //   name: "LicenseType",
              //   label: "LicenseType",
              //   radioOptions: orderTypeOptions,
              //   toggle: true,
              //   disabled: true,
              //   onChange: (value) => {
              //     setLicenseType(value);
              //     const price = calculateLicenseTypePrice(
              //       form.getFieldValue("Model"),
              //       value,
              //       codesData,
              //       modifiedModelsOptions,
              //     );
              //     const siteTypeprice = calculateSiteTypePrice(
              //       form.getFieldValue("SiteType"),
              //       value,
              //       codesData,
              //       modifiedSiteTypes,
              //     );
              //     setLicenseTypePrice(price);
              //     setSiteTypePrice(siteTypeprice);
              //   },
              // },
              {
                label:
                  licenseType === orderTypeOptions[0].value
                    ? "Monthly Price: "
                    : "Additional Price: ",
                renderLabel: true,
                value: `$ ${displayPrice.toFixed(2)}`,
              },
              {
                label: "Apply",
                icon: <CheckCircleOutlined />,
                onClick: () => form.submit(),
                loading: postLoading || putLoading,
              },
              {
                label: "Cancel",
                icon: <CloseOutlined />,
                onClick: onReset,
              },
            ]
          : [
              {
                name: "Expired",
                label: "Expired",
                toggle: true,
                onClick: () => {},
              },
              // {
              //   name: "LicenseType",
              //   label: "LicenseType",
              //   radioOptions: orderTypeOptions,
              //   toggle: true,
              //   disabled: true,
              //   onChange: (value) => {
              //     setLicenseType(value);
              //     const price = calculateLicenseTypePrice(
              //       form.getFieldValue("Model"),
              //       value,
              //       codesData,
              //       modifiedModelsOptions,
              //     );
              //     const siteTypeprice = calculateSiteTypePrice(
              //       form.getFieldValue("SiteType"),
              //       value,
              //       codesData,
              //       modifiedSiteTypes,
              //     );
              //     setLicenseTypePrice(price);
              //     setSiteTypePrice(siteTypeprice);
              //   },
              // },
              {
                label:
                  licenseType === orderTypeOptions[0].value
                    ? "Monthly Price: "
                    : "Additional Price: ",
                renderLabel: true,
                value: `$ ${displayPrice.toFixed(2)}`,
              },
              {
                label: "License Select",
                icon: <FolderOpenOutlined />,
                onClick: () => {
                  setShowCommonModal(true);
                },
              },
              {
                label: "Apply",
                icon: <CheckCircleOutlined />,
                onClick: () => form.submit(),
                loading: postLoading || putLoading,
              },
              {
                label: "Cancel",
                icon: <CloseOutlined />,
                onClick: onReset,
              },
            ];

  useEffect(() => {
    if (
      id &&
      type === "edit" &&
      [3, 6, 10, 11, 12].includes(userData?.role_value)
    ) {
      navigate("/");
    }
  }, []);

  return (
    <div>
      <AccountCreationModal
        isOpenModal={isOpenModal}
        modalType={modalType}
        setIsOpenModal={setIsOpenModal}
        setDefaultData={setDefaultData}
        defaultData={defaultData}
        setModalType={setModalType}
        isModal={true}
        isModalForm={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            {modalType === "OEM" ? (
              <OemIcon className="text-[15px] text-black ml-1" />
            ) : modalType === "Dealer" ? (
              <DealerIcon className="text-[15px] text-black ml-1" />
            ) : modalType === "Customer" ? (
              <AccountIcon className="text-[15px] text-black ml-1" />
            ) : null}
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              {isOpenModal ? `Add ${modalType}` : "Send Invitation"}
            </span>
          </div>
        }
      />
      <CommonModal
        title="Prepurchased License"
        icon={GiftFilled}
        content={
          <GiftCardItemsForm ref={giftCardRef} dealerNo={userData?.dealer_no} />
        }
        isVisible={showGiftCardModal}
        onClose={() => setShowGiftCardModal(false)}
        width={900}
        footerComp={
          <div className="flex justify-center mt-4 gap-4">
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium"
              loading={giftCardPostLoading || putLoading}
              disabled={giftCardPostLoading || putLoading}
              onClick={async () => {
                const selected = giftCardRef.current?.getSelectedRows() ?? [];
                if (!selected.length) {
                  openErrorNotification("Please select at least one item.");
                  return;
                }
                if (!id) {
                  openErrorNotification("Site is not available.");
                  return;
                }
                const usedMac = form.getFieldValue("Mac");
                const usedTime = new Date()
                  .toISOString()
                  .replace(/(\.\d{3})Z$/, "$1000Z");
                const markUsedPayload = {
                  dealer_no: userData?.dealer_no,
                  items: selected.map((row) => {
                    const item = {
                      item_no: row.ItemNo,
                      used_mac: usedMac,
                      used_time: usedTime,
                    };
                    if (row.PurchaseNo != null && row.PurchaseNo !== "") {
                      item.purchase_no = row.PurchaseNo;
                    }
                    const gcn = row.GiftCardNo ?? row.gift_card_no;
                    if (gcn != null && gcn !== "") {
                      item.GiftCardNo = gcn;
                    }
                    return item;
                  }),
                };
                giftCardAwaitingSitePutRef.current = true;
                pendingGiftCardMarkUsedPayloadRef.current = markUsedPayload;
                applyGiftCardRowToSite(selected[0]);
              }}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              Apply
            </Button>
            <Button
              onClick={() => setShowGiftCardModal(false)}
              className="reset-button w-[104px] h-[30px] font-medium"
            >
              <CloseOutlined className="font-medium" />
              Close
            </Button>
          </div>
        }
      />
      <CommonModal
        title="Limited License"
        icon={FaCalendarDays}
        content={
          <LimitedLicenseForm
            ref={limitedLicenseRef}
            currentLimitedCardNo={data?.data?.LimitedCardNo}
            limitedOrderStartDate={data?.data?.LimitedOrderStartDate}
            limitedOrderEndDate={data?.data?.LimitedOrderEndDate}
            dealerDiscountPercent={summaryDealerDiscountPercent}
            entityLabel="site"
            onAlreadyAppliedChange={setLimitedApplyDisabled}
          />
        }
        isVisible={showLimitedLicenseModal}
        onClose={() => {
          setShowLimitedLicenseModal(false);
          setLimitedApplyDisabled(false);
        }}
        width={900}
        footerComp={
          <div className="flex justify-center mt-4 gap-4">
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium"
              disabled={limitedApplyDisabled}
              onClick={() => {
                if (limitedApplyDisabled) {
                  openErrorNotification(
                    "This Limited License is already applied. Select a different item.",
                  );
                  return;
                }
                const selected =
                  limitedLicenseRef.current?.getSelectedRows() ?? [];
                if (!selected.length) {
                  openErrorNotification("Please select at least one item.");
                  return;
                }
                if (!id) {
                  openErrorNotification("Site is not available.");
                  return;
                }

                const selectedCard = selected[0];
                const formFields = form.getFieldsValue(true);
                const effectiveDealerNo = resolveEffectiveDealerNo(formFields);
                const hasDealerForPayment =
                  effectiveDealerNo != null && effectiveDealerNo !== "";
                const { billingType: dealerBillingType, discountPercent } =
                  getDealerMeta(effectiveDealerNo);
                // Dealers: BillingType 1 only. Admins: always allow when dealer exists.
                const shouldShowPaymentModal =
                  hasDealerForPayment &&
                  (isSystemUser ||
                    dealerBillingType == null ||
                    dealerBillingType === 1);

                const cardPrice = Number(selectedCard?.Price);
                if (!Number.isFinite(cardPrice) || cardPrice <= 0) {
                  openErrorNotification(
                    "Selected limited card has no valid price.",
                  );
                  return;
                }

                if (!shouldShowPaymentModal) {
                  openErrorNotification(
                    isSystemUser
                      ? "Dealer is required to make this payment."
                      : "Payment is not available for this dealer billing type.",
                  );
                  return;
                }

                const currentLimitedCardNo = data?.data?.LimitedCardNo;
                const currentCard =
                  limitedLicenseRef.current?.getCardByLimitedCardNo?.(
                    currentLimitedCardNo,
                  );
                const currentTerm =
                  currentCard?.Term ??
                  limitedOrdersPreviewData?.data?.[0]?.Term ??
                  null;
                const currentOrder = pickCurrentLimitedOrder(
                  limitedOrdersPreviewData?.data,
                  currentTerm,
                );
                const summary = buildLimitedLicenseSummary({
                  selectedCard,
                  discountPercent,
                  currentTerm,
                  currentCardBasePrice: currentCard?.Price,
                  currentPaidAmount:
                    currentOrder?.Amount ?? data?.data?.IntercomPrice,
                  currentOrder,
                  currentOrderStartDate: data?.data?.LimitedOrderStartDate,
                  currentOrderEndDate: data?.data?.LimitedOrderEndDate,
                });

                if (!summary?.next?.amount || summary.next.amount <= 0) {
                  openErrorNotification(
                    "Selected limited card has no valid amount.",
                  );
                  return;
                }

                selectedLimitedCardRef.current = selectedCard;
                setLimitedLicenseSummary(summary);
                setShowLimitedLicenseModal(false);
                setLimitedApplyDisabled(false);
                setShowLimitedLicenseSummary(true);
              }}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              Apply
            </Button>
            <Button
              onClick={() => {
                setShowLimitedLicenseModal(false);
                setLimitedApplyDisabled(false);
              }}
              className="reset-button w-[104px] h-[30px] font-medium"
            >
              <CloseOutlined className="font-medium" />
              Close
            </Button>
          </div>
        }
      />
      <Modal
        open={showLimitedLicenseSummary}
        onCancel={() => {
          setShowLimitedLicenseSummary(false);
          setLimitedLicenseSummary(null);
          selectedLimitedCardRef.current = null;
        }}
        closeIcon={false}
        footer={null}
        width={900}
        centered
        destroyOnClose
      >
        <LimitedLicenseConfirmForm
          summary={limitedLicenseSummary}
          onCancel={() => {
            setShowLimitedLicenseSummary(false);
            setLimitedLicenseSummary(null);
            selectedLimitedCardRef.current = null;
            setShowLimitedLicenseModal(true);
          }}
          onConfirm={() => {
            const summary = limitedLicenseSummary;
            const selectedCard = selectedLimitedCardRef.current;
            if (!summary?.next || !selectedCard) {
              openErrorNotification(
                "Limited License summary is not available.",
              );
              return;
            }
            const amountDue = Number(summary.amountDue ?? 0);
            const payback = Number(summary.payback ?? 0);
            const newAmount = Number(summary.next.amount ?? 0);

            setPendingSubmitMode("limited");
            setPendingUpdatePayload({
              LimitedCardNo: selectedCard.LimitedCardNo,
              Term: selectedCard.Term,
              LicenseCode: selectedCard.LicenseCode,
              Price: newAmount,
              Amount: amountDue,
              Payback: payback > 0 ? payback : null,
            });
            setPriceChangeAmount(Math.max(amountDue, 0));
            setShowLimitedLicenseSummary(false);

            if (amountDue > 0) {
              setPaymentModal(true);
              return;
            }

            // Fully covered by payback — create order without charging, then apply license code
            (async () => {
              try {
                const deviceNo =
                  data?.data?.DeviceNo ??
                  (id != null && id !== "" ? Number(id) : null);
                if (deviceNo == null || Number.isNaN(Number(deviceNo))) {
                  openErrorNotification("Site/Device is not available.");
                  return;
                }
                const orderResult = await limitedOrderPostAction({
                  DeviceNo: Number(deviceNo),
                  Amount: 0,
                  Price: newAmount,
                  Payback: payback > 0 ? payback : null,
                  LimitedCardNo: selectedCard.LimitedCardNo,
                });
                if (!orderResult) {
                  openErrorNotification("Limited order failed.");
                  return;
                }
                const licenseCode = Number(selectedCard.LicenseCode);
                const applied = await applyLimitedLicenseIntercomUpdate(
                  licenseCode,
                  newAmount,
                );
                if (!applied) return;
                setPendingUpdatePayload(null);
                setPendingSubmitMode(null);
                setLimitedLicenseSummary(null);
                selectedLimitedCardRef.current = null;
                openConfirmNotification("Success");
                navigate(`/site/info/${id}`);
              } catch (e) {
                openErrorNotification(
                  e?.response?.data?.message ||
                    e?.message ||
                    "Something went wrong",
                );
              }
            })();
          }}
        />
      </Modal>
      <CommonModal
        title="Select License"
        icon={LicenseIcon}
        content={
          <LicenseSelectForm
            setSelectedRow={setSelectedRow}
            type="Initial License"
          />
        }
        isVisible={showCommonModal}
        onClose={() => setShowCommonModal(false)}
        width={900}
        onConfirm={() => {
          if (!individualLicenseData?.data) {
            openErrorNotification("Please select a license before apply.");
            return;
          }
          const currentSiteType = Number(form.getFieldValue("SiteType"));

          let initialLicenseType;

          if ([0, 1, 2].includes(currentSiteType)) {
            initialLicenseType = orderTypeOptions[1].value; // lifetime
          } else if ([3, 4].includes(currentSiteType)) {
            initialLicenseType = orderTypeOptions[0].value; // Monthly
          } else {
            initialLicenseType = 0; // default
          }
          form.setFieldsValue({
            Options: individualLicenseData?.data?.Options?.map((item) =>
              String(item),
            ),
            Product: individualLicenseData?.data?.Product,
            Model: individualLicenseData?.data?.Model,
            Type: individualLicenseData.data.Type,
            SiteType: individualLicenseData?.data?.SiteType,
            // OemNo: individualLicenseData.data.OemNo,
            Invitation: individualLicenseData.data.Invitation
              ? individualLicenseData.data.Invitation * 100
              : undefined,
            Channel: individualLicenseData.data.Channel,
            Lockset: individualLicenseData.data.Lockset,
            Facegate: individualLicenseData.data.Facegate,
            Subnode: individualLicenseData.data.Subnode,
            ContLock: individualLicenseData.data.ContLock,
            Intercom: individualLicenseData.data.Intercom,
            Sicucom:
              individualLicenseData.data.Sicucom != null
                ? Number(individualLicenseData.data.Sicucom)
                : undefined,
          });
          const reconstructedOptionsData = {};

          // Handle toggle options (from Options array)
          if (individualLicenseData?.data?.Options && modifiedOpLicense) {
            individualLicenseData?.data?.Options.forEach((optionValue) => {
              const option = modifiedOpLicense.find(
                (opt) => opt.value === String(optionValue),
              );
              if (option) {
                const itemNo = getItemNoByLabel(option.label);
                reconstructedOptionsData[option.label] = {
                  type: "toggle",
                  enabled: true,
                  value: option.value,
                  itemNo: itemNo,
                  price: getPrice(
                    option.label,
                    codesData,
                    initialLicenseType,
                    1,
                    itemNo,
                  ),
                };
              }
            });
          }
          const inputFields = [
            { label: "Channel", fieldName: "Channel", type: "input" },
            { label: "Lockset", fieldName: "Lockset", type: "input" },
            { label: "Trilogy Lockset", fieldName: "ContLock", type: "input" },
            { label: "Facegate", fieldName: "Facegate", type: "input" },
            { label: "OSDP Door", fieldName: "Subnode", type: "input" },
            { label: "Landline", fieldName: "Intercom", type: "select" },
            {
              label: "Unit",
              fieldName: "Sicucom",
              type: "input",
            },
            {
              label: "Mobile Credential",
              fieldName: "Invitation",
              type: "select",
            },
          ];

          inputFields.forEach(({ label, fieldName, type: cardType }) => {
            const value = individualLicenseData?.data?.[fieldName];
            if (value && value > 0) {
              const quantity = fieldName === "Invitation" ? value * 100 : value;

              const option = modifiedOp?.find((opt) => opt.label === label);
              const itemNo = getItemNoByLabel(label);

              reconstructedOptionsData[label] = {
                type: cardType,
                quantity: quantity,
                fieldName: fieldName,
                value: option?.value || null,
                itemNo: itemNo,
                price:
                  fieldName === "Intercom"
                    ? Number(individualLicenseData?.data?.IntercomPrice ?? 0) ||
                      0
                    : getPrice(
                        label,
                        codesData,
                        initialLicenseType,
                        quantity,
                        itemNo,
                      ),
              };
            }
          });
          setLicenseOptionsData(reconstructedOptionsData);

          // Calculate and set prices
          const price = calculateLicenseTypePrice(
            individualLicenseData?.data?.Model,
            initialLicenseType,
            codesData,
            modifiedModelsOptions,
          );
          const siteTypeprice = calculateSiteTypePrice(
            currentSiteType,
            initialLicenseType,
            codesData,
            modifiedSiteTypes,
          );
          const doorPrice = calculateDoorPrice(
            individualLicenseData?.data?.Type,
            initialLicenseType,
            codesData,
          );

          setLicenseTypePrice(price);
          setSiteTypePrice(siteTypeprice);
          setDoorPrice(doorPrice);
          setShowCommonModal(false);
          if (individualLicenseData?.data?.SiteType != null) {
            setSiteType(individualLicenseData.data.SiteType);
            setLicenseSiteType(individualLicenseData.data.SiteType);
          }
        }}
      />

      <div className="">
        <Form
          validateTrigger={"onChange"}
          form={form}
          onFinish={onFinish}
          scrollToFirstError
          layout={"vertical"}
          autoComplete={"off"}
        >
          <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
            <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
              <CommonButton buttonsData={buttonsData} />
            </CommonBreadcrumb>
          </div>

          <div className="border bg-white rounded-[4px] overflow-hidden">
            <div className="flex items-center bg-gray-200 p-2.5">
              <FaGlobe className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                Site
              </span>
            </div>
            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 8]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Device Name"
                    name="DeviceName"
                    autoComplete="off"
                    disable={type === "info"}
                    loading={loading}
                  />
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Description"
                    name="DeviceDesc"
                    disable={type === "info"}
                    loading={loading}
                  />
                </Col>
                {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Auto Login"
                      name="AutoLogin"
                      options={[
                        { label: "Yes", value: 1 },
                        { label: "No", value: 0 },
                      ]}
                      placeholder="Please select"
                      disabled={type === "info"}
                      onChange={(value) => {
                        setAutoLogin(value);
                      }}
                    />
                  </Col>
                  {autoLogin === 1 && (
                    <>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomInput
                          label="Username"
                          name="UserId"
                          disabled={type === "info"}
                          autoComplete="off"
                          required
                        />
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomInput
                          label="Password"
                          name="Password"
                          type="password"
                          disabled={type === "info"}
                          autoComplete="new-password"
                          required
                        />
                      </Col>
                    </>
                  )} */}
                {/* {type !== "edit" && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomSelect
                        label="Site Type"
                        name="SiteType"
                        options={modifiedSiteTypes}
                        placeholder="Please select"
                        disabled
                      />
                    </Col>
                  )} */}
                {[1, 2, 3].includes(userData?.role_value) && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="OEM"
                      name="OemNo"
                      options={modifiedOems}
                      placeholder="Please select"
                      // value={form.getFieldValue("OemNo")}
                      disabled={type === "info"}
                      required
                      onChange={(value) => {
                        setDefaultData((prev) => ({
                          ...prev,
                          OemNo: value,
                          DealerNo: null,
                          CustomerNo: null,
                        }));
                        setOemNo(value);
                        setDealerNo(null);
                        if (hasRole(7, 8, 9)) {
                          setSiteType(data?.data?.SiteType);
                        } else {
                          setSiteType(0);
                        }
                        form.setFieldsValue({
                          DealerNo: null,
                          CustomerNo: null,
                          SiteType: hasRole(7, 8, 9) ? data?.data?.SiteType : 0,
                        });
                      }}
                      handleCreateNew={handleCreateNew}
                      type={"OEM"}
                      loading={loading}
                      allowClear={false}
                    />
                  </Col>
                )}
                {[1, 2, 3, 4, 5, 6].includes(userData?.role_value) && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Dealer"
                      name="DealerNo"
                      options={modifiedDealers}
                      placeholder="Please select"
                      disabled={type === "info" || !defaultData?.OemNo}
                      onChange={(value) => {
                        setDefaultData((prev) => ({
                          ...prev,
                          DealerNo: value,
                          CustomerNo: null,
                        }));
                        setDealerNo(value);
                        form.setFieldsValue({
                          CustomerNo: null,
                        });
                        if (!value) {
                          form.setFieldsValue({
                            SiteType: hasRole(7, 8, 9)
                              ? data?.data?.SiteType
                              : 0,
                          });
                        }
                      }}
                      handleCreateNew={handleCreateNew}
                      type={"Dealer"}
                      loading={loading}

                      // customPlaceholderColor
                    />
                  </Col>
                )}
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value) && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Customer"
                      name="CustomerNo"
                      options={modifiedCustomers}
                      placeholder="Please select"
                      disabled={
                        type === "info" ||
                        (!defaultData?.DealerNo && !hasRole(7, 8, 9))
                      }
                      handleCreateNew={handleCreateNew}
                      type={"Customer"}
                      loading={loading}
                    />
                  </Col>
                )}

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Site Type"
                    name="SiteType"
                    options={
                      ["edit", "info"].includes(type)
                        ? form.getFieldValue("SiteType") === 3
                          ? modifiedSiteTypeOptions?.filter(
                              (item) => item.value === 3,
                            )
                          : form.getFieldValue("SiteType") === 4
                            ? modifiedSiteTypeOptions?.filter(
                                (item) => item.value === 4,
                              )
                            : hasRole(7, 8, 9) &&
                                form.getFieldValue("SiteType") == null
                              ? modifiedSiteTypeOptions?.filter((item) =>
                                  [3, 4].includes(item.value),
                                )
                              : modifiedSiteTypeOptions?.filter(
                                  (item) => ![3, 4].includes(item.value),
                                )
                        : hasRole(7, 8, 9)
                          ? modifiedSiteTypeOptions?.filter((item) =>
                              [3, 4].includes(item.value),
                            )
                          : modifiedSiteTypeOptions
                    }
                    placeholder="Please select"
                    loading={loading}
                    disabled={type === "info"}
                    onChange={(value) => {
                      handleSiteTypeChange(value);
                      setSiteType(value);
                    }}
                    allowClear={false}
                    showIcons
                    postfix={
                      <span className="flex items-center">
                        <span className="h-7 border-l border-gray-300 mr-2"></span>
                        <span
                          className={`text-xs font-medium mr-1 ${isPriceChanged(siteTypePrice, origSiteTypePrice) ? "text-green-600" : "text-gray-500"}`}
                        >
                          $
                        </span>
                        <span
                          className={`text-xs font-medium ${isPriceChanged(siteTypePrice, origSiteTypePrice) ? "text-green-600" : "text-gray-800"}`}
                        >
                          {siteTypePrice.toFixed(2)}
                        </span>
                      </span>
                    }
                  />
                </Col>
                {[0, 1, 2].includes(sitetype) &&
                (type === "info" || isSystemUser) ? (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Product"
                      name="Product"
                      options={modifiedProductOptions}
                      placeholder="Please select"
                      showIcons
                      disabled={
                        [3, 4].includes(form.getFieldValue("SiteType")) ||
                        type === "info" ||
                        userData?.role_value >= 10
                      }
                      required
                      loading={loading}
                    />
                  </Col>
                ) : null}
                {[0, 1, 2].includes(sitetype) &&
                (type === "info" || isSystemUser) ? (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="MAC"
                      name="Mac"
                      disable={id || type === "info"}
                      loading={loading}
                      rules={[{ validator: macValidator }]}
                      required={[0, 1, 2].includes(sitetype)}
                    />
                  </Col>
                ) : null}
                {type === "info" && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Site Key"
                      name="SiteKey"
                      disabled
                      loading={loading}
                    />
                  </Col>
                )}
                {type === "info" && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="License Key"
                      name="LicenseKey"
                      disabled
                      loading={loading}
                    />
                  </Col>
                )}
                {type === "info" && isSystemUser && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Add Time"
                      name="AddTime"
                      disabled
                      loading={loading}
                    />
                  </Col>
                )}
                {type === "info" && isSystemUser && (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Activate Time"
                      name="ActTime"
                      disabled
                      loading={loading}
                    />
                  </Col>
                )}
                {/* {[2, 3].includes(form.getFieldValue("SiteType")) &&
                  type === "info" &&
                  isSystemUser && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Start Time"
                        name="StartTime"
                        disabled
                        loading={loading}
                      />
                    </Col>
                  )}
                {[2, 3].includes(form.getFieldValue("SiteType")) &&
                  type === "info" &&
                  isSystemUser && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="End Time"
                        name="EndTime"
                        disabled
                        loading={loading}
                      />
                    </Col>
                  )} */}
              </Row>
            </div>
          </div>

          <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
            <div className="flex items-center bg-gray-200 p-2.5">
              <InfoCircleOutlined className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                License Information
              </span>
            </div>
            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 8]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Model"
                    name="Model"
                    options={modifiedModelsOptions}
                    placeholder="Please select"
                    disabled={type === "info" || userData?.role_value >= 10}
                    required
                    loading={loading}
                    onChange={handleModelChange}
                    showIcons
                    postfix={
                      <span className="flex items-center">
                        <span className="h-7 border-l border-gray-300 mr-2"></span>
                        <span
                          className={`text-xs font-medium mr-1 ${isPriceChanged(licenseTypePrice, origModelPrice) ? "text-green-600" : "text-gray-500"}`}
                        >
                          $
                        </span>
                        <span
                          className={`text-xs font-medium ${isPriceChanged(licenseTypePrice, origModelPrice) ? "text-green-600" : "text-gray-800"}`}
                        >
                          {licenseTypePrice.toFixed(2)}
                        </span>
                      </span>
                    }
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Door"
                    name="Type"
                    disabled={type === "info"}
                    type="number"
                    integerOnly
                    required
                    prefix={<DoorTypeIcon />}
                    loading={loading}
                    onChange={handleDoorChange}
                    rules={[
                      {
                        required: true,
                        message: "Door is required",
                      },
                      {
                        validator: (_, value) => {
                          if (value && value > 65535) {
                            return Promise.reject(
                              new Error(
                                "Door must be less than or equal to 65535!",
                              ),
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                    postfix={
                      <span className="flex items-center">
                        <span className="h-7 border-l border-gray-300 mr-2"></span>
                        <span
                          className={`text-xs font-medium mr-1 ${isPriceChanged(doorPrice, origDoorPrice) ? "text-green-600" : "text-gray-500"}`}
                        >
                          $
                        </span>
                        <span
                          className={`text-xs font-medium ${isPriceChanged(doorPrice, origDoorPrice) ? "text-green-600" : "text-gray-800"}`}
                        >
                          {doorPrice.toFixed(2)}
                        </span>
                      </span>
                    }
                  />
                </Col>
              </Row>
            </div>
          </div>
          <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
            <div className="flex items-center bg-gray-200 p-2.5">
              <SettingOutlined className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                License Options
              </span>
            </div>
            <div className={`px-2 py-3 grid gap-4`}>
              <OptionCards
                name="Options"
                options={modifiedOp}
                disabled={type === "info"}
                loading={loading || codesDataLoading}
                codesData={codesData}
                type={licenseType}
                value={licenseOptionsData}
                onChange={setLicenseOptionsData}
              />
            </div>
            {/* <div className="px-2 py-3 grid gap-4">
              <CustomCheckbox
                label=""
                name="Options"
                options={modifiedOp}
                disabled={type === "info"}
              />
            </div> */}
          </div>

          {type === "info" && data?.data?.Guest ? (
            <div className="mt-4 bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5 ">
                <InfoCircleOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  Customer Information
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="First Name"
                      name="FirstName"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Last Name"
                      name="LastName"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Installing Company"
                      name="Company"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Email"
                      name="Email"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Phone"
                      name="Phone"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Address"
                      name="Address2"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Install Type"
                      name="InstallType"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Suggestion"
                      name="Suggestion"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          ) : null}

          {type === "info" &&
            ![3, 4].includes(form.getFieldValue("SiteType")) &&
            isSystemUser && (
              <div className="mt-4 bg-white rounded-[4px] overflow-hidden">
                <div className="flex items-center bg-gray-200 p-2.5 ">
                  <InfoCircleOutlined className="text-[18px] text-black " />
                  <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                    Status
                  </span>
                </div>
                <div className="px-2 pt-1 pb-3">
                  <Row gutter={[16, 8]}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Proxy Server"
                        name="ProxyServer"
                        disabled={type === "info"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Secure Port"
                        name="SecurePort"
                        disabled={type === "info"}
                      />
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Debug Port"
                        name="DebugPort"
                        disabled={type === "info"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Version"
                        name="Version"
                        disabled={type === "info"}
                      />
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Address"
                        name="Address"
                        disabled={type === "info"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="HTTPS"
                        name="Https"
                        disabled={type === "info"}
                      />
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Timezone"
                        name="Timezone"
                        disabled={type === "info"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Online"
                        name="Online"
                        disabled={type === "info"}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            )}
          {[1, 2, 3, 4].includes(form.getFieldValue("SiteType")) && (
            <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5">
                <LoginOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  Authentication
                </span>
              </div>

              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Auto Login"
                      name="AutoLogin"
                      options={[
                        { label: "Yes", value: 1 },
                        { label: "No", value: 0 },
                      ]}
                      placeholder="Please select"
                      disabled={type === "info"}
                      onChange={(value) => {
                        setAutoLogin(value);
                      }}
                    />
                  </Col>
                  {autoLogin === 1 && (
                    <>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomInput
                          label="Username"
                          name="UserId"
                          disabled={type === "info"}
                          autoComplete="off"
                          required
                        />
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomInput
                          label="Password"
                          name="Password"
                          type="password"
                          disabled={type === "info"}
                          autoComplete="new-password"
                          required
                          noValidation
                        />
                      </Col>
                    </>
                  )}
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Blocked"
                      name="Blocked"
                      options={[
                        { label: "Yes", value: 1 },
                        { label: "No", value: 0 },
                      ]}
                      placeholder="Please select"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          )}
        </Form>
      </div>

      <Modal
        open={showSummaryModal}
        onCancel={() => setShowSummaryModal(false)}
        closeIcon={false}
        footer={null}
        width={750}
        centered
        motion={false}
        destroyOnClose={true}
      >
        <LicenseConfirmForm
          onConfirm={handleConfirmSubmit}
          onCancel={() => setShowSummaryModal(false)}
          mergedData={pendingFormData}
          optionsData={licenseOptionsData}
          licenseType={licenseType}
          siteTypePrice={siteTypePrice}
          modelsOptions={modifiedModelsOptions}
          siteTypeOptions={modifiedSiteTypeOptions}
          setLicenseType={setLicenseType}
          licenseTypePrice={licenseTypePrice}
          doorPrice={doorPrice}
          form={form}
          loading={postLoading || putLoading}
          disableSelect
          edit={id && type === "edit"}
          originalLicenseData={originalLicenseData}
          dealerDiscountPercent={summaryDealerDiscountPercent}
        />
      </Modal>

      <Modal
        open={showCardsModal}
        onCancel={() => {
          setShowCardsModal(false);
          setCardsModalDealerNo(null);
        }}
        closeIcon={false}
        footer={null}
        width={520}
        centered
        motion={false}
        destroyOnClose
      >
        <ManageCardsModal
          setIsModalOpen={(open) => {
            setShowCardsModal(!!open);
            if (!open) setCardsModalDealerNo(null);
          }}
          dealerNo={cardsModalDealerNo}
          requiredMessage={AUTOBILLING_CARD_REQUIRED_MESSAGE}
        />
      </Modal>

      <Modal
        title={
          <div className="flex items-center justify-between bg-gray-200 p-2.5 rounded-md">
            <div className="flex items-center">
              <PaymentIcon className="text-[18px] text-black " />
              <span className="text-[14px] font-[Poppins] text-black ml-2">
                Make Payment
              </span>
            </div>
          </div>
        }
        open={paymentModal}
        onCancel={() => {
          setPaymentModal(false);
          // Admin: manual only; dealer: card only (see PaymentForm showCardLayout)
          setShowCardLayout(!isSystemUser);
          setPendingUpdatePayload(null);
          setPendingSubmitMode(null);
          setPriceChangeAmount(0);
          selectedLimitedCardRef.current = null;
        }}
        footer={null}
        closeIcon={false}
        width={560}
        centered
        destroyOnClose
      >
        <MyPaymentForm
          DealerNo={
            data?.data?.DealerNo
              ? data?.data?.DealerNo
              : hasRole(7, 8, 9)
                ? userData?.dealer_no
                : dealerNo
          }
          amount={`$${Number(priceChangeAmount || 0).toFixed(2)}`}
          setPaymentModal={setPaymentModal}
          InvoiceNo={id}
          OrderName={data?.data?.DeviceName}
          refetch={() => {}}
          showCardLayout={showCardLayout}
          setShowCardLayout={setShowCardLayout}
          billingType={
            getDealerMeta(
              data?.data?.DealerNo
                ? data?.data?.DealerNo
                : hasRole(7, 8, 9)
                  ? userData?.dealer_no
                  : dealerNo,
            ).billingType
          }
          licensePeriod={
            pendingUpdatePayload?.LicenseType ??
            licenseType ??
            form.getFieldValue("LicenseType") ??
            0
          }
          beforePayment={async () => {
            // Limited License: charge only for now (site apply comes later)
            if (pendingSubmitMode === "limited") {
              if (!pendingUpdatePayload) return false;
              paymentFlowInProgressRef.current = true;
              return true;
            }
            if (!pendingUpdatePayload || !pendingSubmitMode) return false;
            paymentFlowInProgressRef.current = true;
            const payload = pendingUpdatePayload;
            const mode = pendingSubmitMode;
            try {
              const result =
                mode === "create"
                  ? await postAction(payload)
                  : await putAction(payload);
              if (!result) {
                paymentFlowInProgressRef.current = false;
                return false;
              }
              return true;
            } catch (e) {
              paymentFlowInProgressRef.current = false;
              return false;
            }
          }}
          onPaymentSuccess={async (paymentResponse) => {
            paymentFlowInProgressRef.current = false;
            if (!pendingUpdatePayload) return;

            const mode = pendingSubmitMode;
            const pending = pendingUpdatePayload;
            const limitedCard = selectedLimitedCardRef.current;

            if (mode === "limited") {
              const paymentNo =
                paymentResponse?.data?.PaymentNo ??
                paymentResponse?.PaymentNo ??
                paymentResponse?.data?.data?.PaymentNo ??
                null;
              const deviceNo =
                data?.data?.DeviceNo ??
                (id != null && id !== "" ? Number(id) : null);
              const amount = Number(
                pending?.Amount ?? pending?.Price ?? priceChangeAmount ?? 0,
              );
              const payback =
                pending?.Payback != null && pending?.Payback !== ""
                  ? Number(pending.Payback)
                  : null;
              const price = Number(pending?.Price);
              const limitedCardNo =
                pending?.LimitedCardNo ?? limitedCard?.LimitedCardNo ?? null;
              const licenseCode = Number(
                pending?.LicenseCode ?? limitedCard?.LicenseCode,
              );

              if (!paymentNo) {
                openErrorNotification(
                  "Payment succeeded but PaymentNo is missing.",
                );
                throw new Error("PaymentNo is missing");
              }
              if (deviceNo == null || Number.isNaN(Number(deviceNo))) {
                openErrorNotification("Site/Device is not available.");
                throw new Error("DeviceNo is missing");
              }
              if (limitedCardNo == null) {
                openErrorNotification("Limited card is not available.");
                throw new Error("LimitedCardNo is missing");
              }
              if (!Number.isFinite(licenseCode) || licenseCode < 0) {
                openErrorNotification(
                  "Selected limited card has no valid License Code.",
                );
                throw new Error("LicenseCode is missing");
              }

              const orderPayload = {
                PaymentNo: paymentNo,
                DeviceNo: Number(deviceNo),
                Amount: Number.isFinite(amount) ? amount : 0,
                LimitedCardNo: limitedCardNo,
              };
              if (Number.isFinite(price) && price >= 0) {
                orderPayload.Price = price;
              }
              if (Number.isFinite(payback) && payback > 0) {
                orderPayload.Payback = payback;
              }

              const orderResult = await limitedOrderPostAction(orderPayload);

              if (!orderResult) {
                openErrorNotification(
                  "Payment succeeded but limited order failed.",
                );
                throw new Error("Limited order failed");
              }

              const applied = await applyLimitedLicenseIntercomUpdate(
                licenseCode,
                pending?.Price ?? amount,
              );
              if (!applied) {
                throw new Error("Site Intercom update failed");
              }
            }

            setPendingUpdatePayload(null);
            setPendingSubmitMode(null);
            setPriceChangeAmount(0);
            setLimitedLicenseSummary(null);
            selectedLimitedCardRef.current = null;
            // Navigate after the user closes the payment-success modal
            return () => {
              if (id) {
                navigate(`/site/info/${id}`);
              } else {
                navigate(-1);
              }
            };
          }}
        />
      </Modal>

      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
      />
    </div>
  );
};
